(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7978],{

/***/ 33884:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shadow-puppet",
      function () {
        return __webpack_require__(26902);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57247);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CardBody = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-df4f0a61-0"
}).withConfig({
    componentId: "sc-657c9e-0"
})(_templateObject(), styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
CardBody.defaultProps = {
    p: "24px"
};
/* harmony default export */ __webpack_exports__["Z"] = (CardBody);


/***/ }),

/***/ 55209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57247);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CardHeader = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e97edbbd-0"
}).withConfig({
    componentId: "sc-206fd2b9-0"
})(_templateObject(), function(param) {
    var theme = param.theme, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant;
    return theme.card.cardHeaderBackground[variant];
}, function(param) {
    var theme = param.theme;
    return "".concat(theme.radii.card, " ").concat(theme.radii.card, " 0 0");
}, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
CardHeader.defaultProps = {
    p: "24px"
};
/* harmony default export */ __webpack_exports__["Z"] = (CardHeader);


/***/ }),

/***/ 79207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Progress_Progress; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/components/Progress/StyledProgress.tsx + 1 modules
var StyledProgress = __webpack_require__(6531);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Progress/ProgressBunnyWrapper.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  z-index: 2;\n  top: -65%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n  transition: left 200ms ease-out;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ProgressBunnyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a698ef92-0"
}).withConfig({
    componentId: "sc-d864b77e-0"
})(_templateObject());
/* harmony default export */ var Progress_ProgressBunnyWrapper = (ProgressBunnyWrapper);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ProgressBunny.tsx
var ProgressBunny = __webpack_require__(62968);
// EXTERNAL MODULE: ./packages/uikit/src/components/Progress/types.ts
var types = __webpack_require__(94065);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Progress/Progress.tsx






var stepGuard = function stepGuard(step) {
    if (step < 0) {
        return 0;
    }
    if (step > 100) {
        return 100;
    }
    return step;
};
var Progress = function Progress(param) {
    var _variant = param.variant, variant = _variant === void 0 ? types/* variants.ROUND */.o.ROUND : _variant, _scale = param.scale, scale = _scale === void 0 ? types/* scales.MD */.Q.MD : _scale, _primaryStep = param.primaryStep, primaryStep = _primaryStep === void 0 ? 0 : _primaryStep, _secondaryStep = param.secondaryStep, secondaryStep = _secondaryStep === void 0 ? null : _secondaryStep, _showProgressBunny = param.showProgressBunny, showProgressBunny = _showProgressBunny === void 0 ? false : _showProgressBunny, _useDark = param.useDark, useDark = _useDark === void 0 ? true : _useDark, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProgress/* default */.Z, {
        $useDark: useDark,
        variant: variant,
        scale: scale,
        children: children || /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                showProgressBunny && /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress_ProgressBunnyWrapper, {
                    style: {
                        left: "".concat(stepGuard(primaryStep), "%")
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBunny/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProgress/* Bar */.$, {
                    $useDark: useDark,
                    primary: true,
                    style: {
                        width: "".concat(stepGuard(primaryStep), "%")
                    }
                }),
                secondaryStep ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProgress/* Bar */.$, {
                    $useDark: useDark,
                    style: {
                        width: "".concat(stepGuard(secondaryStep), "%")
                    }
                }) : null
            ]
        })
    });
};
/* harmony default export */ var Progress_Progress = (Progress);


/***/ }),

/***/ 6531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Bar; },
  "Z": function() { return /* binding */ Progress_StyledProgress; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
// EXTERNAL MODULE: ./packages/uikit/src/theme/colors.ts
var colors = __webpack_require__(16557);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./packages/uikit/src/components/Progress/types.ts
var types = __webpack_require__(94065);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Progress/themes.ts


var _obj;
var styleVariants = (_obj = {}, (0,_define_property/* default */.Z)(_obj, types/* variants.ROUND */.o.ROUND, {
    borderRadius: "32px"
}), (0,_define_property/* default */.Z)(_obj, types/* variants.FLAT */.o.FLAT, {
    borderRadius: 0
}), _obj);
var _obj1;
var styleScales = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, types/* scales.MD */.Q.MD, {
    height: "16px"
}), (0,_define_property/* default */.Z)(_obj1, types/* scales.SM */.Q.SM, {
    height: "8px"
}), _obj1);
/* harmony default export */ var themes = ((/* unused pure expression or super */ null && (styleVariants)));

;// CONCATENATED MODULE: ./packages/uikit/src/components/Progress/StyledProgress.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: ",
        ";\n  height: 100%;\n  transition: width 200ms ease;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  overflow: hidden;\n\n  ",
        " {\n    border-top-left-radius: ",
        ";\n    border-bottom-left-radius: ",
        ";\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Bar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-347a4242-0"
}).withConfig({
    componentId: "sc-ffa90952-0"
})(_templateObject(), function(param) {
    var theme = param.theme, $useDark = param.$useDark, primary = param.primary, $background = param.$background;
    if ($background) return $background;
    if ($useDark) return primary ? theme.colors.secondary : "".concat(theme.colors.secondary80);
    return primary ? colors/* lightColors.secondary */.C.secondary : "".concat(colors/* lightColors.secondary80 */.C.secondary80);
});
Bar.defaultProps = {
    primary: false
};
var StyledProgress = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-347a4242-1"
}).withConfig({
    componentId: "sc-ffa90952-1"
})(_templateObject1(), function(param) {
    var theme = param.theme, $useDark = param.$useDark;
    return $useDark ? theme.colors.input : colors/* lightColors.input */.C.input;
}, function(param) {
    var theme = param.theme;
    return theme.shadows.inset;
}, Bar, function(param) {
    var variant = param.variant;
    return variant === types/* variants.FLAT */.o.FLAT ? "0" : "32px";
}, function(param) {
    var variant = param.variant;
    return variant === types/* variants.FLAT */.o.FLAT ? "0" : "32px";
}, (0,index_esm/* variant */.bU)({
    variants: styleVariants
}), (0,index_esm/* variant */.bU)({
    prop: "scale",
    variants: styleScales
}), index_esm/* space */.Dh);
/* harmony default export */ var Progress_StyledProgress = (StyledProgress);


/***/ }),

/***/ 94065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ scales; },
/* harmony export */   "o": function() { return /* binding */ variants; }
/* harmony export */ });
var variants = {
    ROUND: "round",
    FLAT: "flat"
};
var scales = {
    MD: "md",
    SM: "sm"
};


/***/ }),

/***/ 99018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Step; }
/* harmony export */ });
/* unused harmony export StepNumber */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var _Box_Flex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75943);
/* harmony import */ var _Box_Box__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    justify-content: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  width: 4px;\n  height: calc(50% + 20px);\n  ",
        "\n  left: calc(50% - 2px);\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    visibility: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  ",
        " {\n    display: block;\n    margin-right: 16px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: 8px;\n  ",
        " {\n    margin-left: 16px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  box-shadow: 0px 1px 4px rgba(25, 19, 38, 0.15);\n  background-color: ",
        ";\n  border: 2px solid ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 600;\n  font-size: 32px;\n  width: 48px;\n  height: 48px;\n  z-index: 5;\n  ",
        " {\n    font-size: 40px;\n    width: 80px;\n    height: 80px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var getStepNumberFontColor = function getStepNumberFontColor(param) {
    var theme = param.theme, status = param.status;
    if (status === "past") {
        return theme.colors.success;
    }
    if (status === "current") {
        return theme.colors.invertedContrast;
    }
    return theme.colors.textDisabled;
};
var StyledStep = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Box_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d478b30a-0"
}).withConfig({
    componentId: "sc-c17a205b-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var Connector = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d478b30a-1"
}).withConfig({
    componentId: "sc-c17a205b-1"
})(_templateObject1(), function(param) {
    var $isFirstStep = param.$isFirstStep, $isLastStep = param.$isLastStep, $isFirstPart = param.$isFirstPart;
    if ($isFirstStep) return "top: 50%;";
    if ($isLastStep) return "top: 0;";
    return $isFirstPart ? "top:0;" : "top:50%;";
}, function(param) {
    var theme = param.theme, status = param.status;
    return theme.colors[status === "past" || status === "current" ? "success" : "textDisabled"];
});
var ChildrenWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Box_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d478b30a-2"
}).withConfig({
    componentId: "sc-c17a205b-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "visible" : "hidden";
});
var ChildrenLeftWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ChildrenWrapper).withConfig({
    componentId: "sc-d478b30a-3"
}).withConfig({
    componentId: "sc-c17a205b-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var ChildrenRightWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ChildrenWrapper).withConfig({
    componentId: "sc-d478b30a-4"
}).withConfig({
    componentId: "sc-c17a205b-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d478b30a-5"
}).withConfig({
    componentId: "sc-c17a205b-5"
})(_templateObject5());
var StepNumber = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d478b30a-6"
}).withConfig({
    componentId: "sc-c17a205b-6"
})(_templateObject6(), function(param) {
    var theme = param.theme, status = param.status;
    return theme.colors[status === "current" ? "secondary" : "invertedContrast"];
}, function(param) {
    var theme = param.theme, status = param.status;
    return status === "past" ? theme.colors.success : "transparent";
}, function(param) {
    var theme = param.theme;
    return theme.radii.circle;
}, getStepNumberFontColor, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
/**
 * ChildrenLeftWrapper and ChildrenRightWrapper are used on the non mobile version, to force the alternate layout.
 * One of the child is hidden based on the step number.
 */ var Step = function Step(param) {
    var index = param.index, statusFirstPart = param.statusFirstPart, statusSecondPart = param.statusSecondPart, _numberOfSteps = param.numberOfSteps, numberOfSteps = _numberOfSteps === void 0 ? 0 : _numberOfSteps, children = param.children;
    var isIndexPair = index % 2 === 0;
    var isFirst = index === 0;
    var isLast = index === numberOfSteps - 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledStep, {
        mb: index < numberOfSteps - 1 ? "16px" : 0,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ChildrenLeftWrapper, {
                isVisible: !isIndexPair,
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StepNumber, {
                        status: statusFirstPart,
                        children: index + 1
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Connector, {
                        $isFirstStep: isFirst,
                        $isLastStep: isLast,
                        status: statusFirstPart,
                        $isFirstPart: true
                    }),
                    !isFirst && !isLast && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Connector, {
                        $isFirstStep: isFirst,
                        $isLastStep: isLast,
                        status: statusSecondPart
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ChildrenRightWrapper, {
                isVisible: isIndexPair,
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 6999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: fit-content;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StepperWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aff90cdd-0"
}).withConfig({
    componentId: "sc-54d67177-0"
})(_templateObject());
var Stepper = function Stepper(param) {
    var children = param.children;
    var numberOfSteps = react__WEBPACK_IMPORTED_MODULE_2__.Children.count(children);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StepperWrapper, {
        children: react__WEBPACK_IMPORTED_MODULE_2__.Children.map(children, function(child) {
            if (/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.isValidElement(child)) {
                return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.cloneElement(child, {
                    numberOfSteps: numberOfSteps
                });
            }
            return child;
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Stepper);


/***/ }),

/***/ 12851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9.00012 16.2L5.50012 12.7C5.11012 12.31 4.49012 12.31 4.10012 12.7C3.71012 13.09 3.71012 13.71 4.10012 14.1L8.29012 18.29C8.68012 18.68 9.31012 18.68 9.70012 18.29L20.3001 7.70001C20.6901 7.31001 20.6901 6.69001 20.3001 6.30001C19.9101 5.91001 19.2901 5.91001 18.9001 6.30001L9.00012 16.2Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 16123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 66027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 18 18",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9 1.625c2.407 0 2.685.01 3.641.052.874.04 1.358.185 1.666.308.422.165.72.36 1.04.669.318.319.514.617.668 1.039.123.318.267.792.308 1.666.042.946.052 1.234.052 3.641s-.01 2.685-.052 3.641c-.04.874-.185 1.358-.308 1.666-.165.422-.36.72-.669 1.04a2.66 2.66 0 01-1.039.668c-.318.123-.792.267-1.666.308-.946.042-1.234.052-3.641.052s-2.685-.01-3.641-.052c-.874-.04-1.358-.185-1.666-.308a2.911 2.911 0 01-1.04-.669 2.659 2.659 0 01-.668-1.039c-.123-.318-.267-.792-.308-1.666-.042-.946-.052-1.234-.052-3.641s.01-2.685.052-3.641c.04-.874.185-1.358.308-1.666.165-.422.36-.72.669-1.04a2.658 2.658 0 011.039-.668c.318-.123.792-.267 1.666-.308.956-.042 1.234-.052 3.641-.052zM9 0C6.552 0 6.254.01 5.287.051c-.957.052-1.615.196-2.18.422a4.311 4.311 0 00-1.595 1.039A4.311 4.311 0 00.473 3.106c-.226.566-.37 1.224-.422 2.18C.011 6.255 0 6.553 0 9s.01 2.746.051 3.713c.042.957.196 1.615.422 2.18.226.597.535 1.091 1.039 1.595.504.504.998.813 1.594 1.039.576.226 1.224.37 2.18.422.957.04 1.266.051 3.714.051s2.746-.01 3.713-.051c.957-.042 1.615-.196 2.18-.422a4.311 4.311 0 001.595-1.039 4.311 4.311 0 001.039-1.594c.226-.576.37-1.224.422-2.18.04-.957.051-1.266.051-3.714s-.01-2.746-.051-3.713c-.042-.957-.196-1.615-.422-2.18a4.312 4.312 0 00-1.039-1.595A4.311 4.311 0 0014.894.473c-.576-.226-1.224-.37-2.18-.422C11.745.011 11.447 0 9 0z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9 4.382a4.618 4.618 0 100 9.236 4.618 4.618 0 000-9.236zm0 7.621A3.007 3.007 0 015.997 9 3.007 3.007 0 019 5.997 3.007 3.007 0 0112.003 9 3.007 3.007 0 019 12.003zM13.803 5.277a1.08 1.08 0 100-2.16 1.08 1.08 0 000 2.16z"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 62968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 34 38"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "8.83594",
                width: "5.30132",
                height: "17.3191",
                rx: "2.65066",
                fill: "#D1884F"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "19.4385",
                width: "5.30132",
                height: "17.3191",
                rx: "2.65066",
                fill: "#D1884F"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8.5 13.0084C13.1944 8.40751 20.8056 8.40751 25.5 13.0084C30.1944 17.6093 30.1944 25.0689 25.5 29.6698L17.6538 37.3597C17.2927 37.7136 16.7073 37.7136 16.3462 37.3597L8.5 29.6698C3.80558 25.0689 3.80558 17.6093 8.5 13.0084Z",
                fill: "#D1884F"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                cx: "12.3696",
                cy: "19.9172",
                rx: "1.76711",
                ry: "2.59786",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                cx: "21.2056",
                cy: "19.9172",
                rx: "1.76711",
                ry: "2.59786",
                fill: "white"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 91714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Timeline_Timeline; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/uikit/src/theme/colors.ts
var colors = __webpack_require__(16557);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(75943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/CircleOutline.tsx
var CircleOutline = __webpack_require__(16123);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Logo.tsx
var Logo = __webpack_require__(67952);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/CheckmarkCircleFill.tsx
var CheckmarkCircleFill = __webpack_require__(95984);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(88896);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Info.tsx
var Info = __webpack_require__(95459);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Timeline/InfoTooltip.tsx







var InfoTooltip = function InfoTooltip(_param) {
    var text = _param.text, _iconColor = _param.iconColor, iconColor = _iconColor === void 0 ? "textSubtle" : _iconColor, props = (0,_object_without_properties/* default */.Z)(_param, [
        "text",
        "iconColor"
    ]);
    var ref = (0,useTooltip/* default */.Z)(text, {}), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        alignItems: "center",
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                ref: targetRef,
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                    color: iconColor
                })
            })
        ]
    }));
};
/* harmony default export */ var Timeline_InfoTooltip = (InfoTooltip);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Timeline/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  display: flex;\n  position: relative;\n  margin-bottom: 14px;\n\n  &:after {\n    content: "";\n    position: absolute;\n    left: 9px;\n    top: 26px;\n    width: 2px;\n    height: 10px;\n    background-color: ',
        ";\n  }\n\n  &:last-child:after {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var TimelineContainer = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-1a46d3f-0"
}).withConfig({
    componentId: "sc-cea026e5-0"
})(_templateObject());
var TimelineEvent = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-1a46d3f-1"
}).withConfig({
    componentId: "sc-cea026e5-1"
})(_templateObject1(), function(param) {
    var theme = param.theme, $useDark = param.$useDark;
    return $useDark ? theme.colors.textSubtle : colors/* lightColors.textSubtle */.C.textSubtle;
});

;// CONCATENATED MODULE: ./packages/uikit/src/components/Timeline/Timeline.tsx







var getTextColor = function getTextColor(param) {
    var eventStatus = param.eventStatus, useDark = param.useDark;
    if (eventStatus === "upcoming") return useDark ? "textDisabled" : colors/* lightColors.textDisabled */.C.textDisabled;
    if (eventStatus === "live") return "success";
    return useDark ? "textSubtle" : colors/* lightColors.textSubtle */.C.textSubtle;
};
var Timeline = function Timeline(param) {
    var events = param.events, _useDark = param.useDark, useDark = _useDark === void 0 ? true : _useDark;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineContainer, {
        children: events.map(function(param) {
            var text = param.text, status = param.status, altText = param.altText, infoText = param.infoText;
            var isUpcoming = status === "upcoming";
            var isLive = status === "live";
            var isPast = status === "past";
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimelineEvent, {
                $useDark: useDark,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        mr: "10px",
                        alignItems: "center",
                        children: [
                            isUpcoming && /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleOutline/* default */.Z, {
                                color: useDark ? "textDisabled" : colors/* lightColors.textDisabled */.C.textDisabled
                            }),
                            isLive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {}),
                            isPast && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckmarkCircleFill/* default */.Z, {
                                color: useDark ? "textSubtle" : colors/* lightColors.textSubtle */.C.textSubtle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: getTextColor({
                            eventStatus: status,
                            useDark: useDark
                        }),
                        bold: true,
                        children: text
                    }),
                    altText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "warning",
                        ml: "2px",
                        bold: true,
                        children: altText
                    }),
                    infoText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Timeline_InfoTooltip, {
                        text: infoText,
                        ml: "10px",
                        iconColor: useDark ? "textSubtle" : colors/* lightColors.textSubtle */.C.textSubtle
                    })
                ]
            }, text);
        })
    });
};
/* harmony default export */ var Timeline_Timeline = (Timeline);


/***/ }),

/***/ 95122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75943);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62077);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56063);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52775);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  button {\n    align-items: center;\n    justify-content: flex-start;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  height: ",
        ";\n  padding-bottom: ",
        ";\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8285e73f-0"
})(_templateObject());
var StyledExpandableLabelWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8285e73f-1"
})(_templateObject1());
var StyledChildrenFlex = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8285e73f-2"
})(_templateObject2(), function(param) {
    var isExpanded = param.isExpanded;
    return isExpanded ? "100%" : "0px";
}, function(param) {
    var isExpanded = param.isExpanded;
    return isExpanded ? "16px" : "0px";
}, function(param) {
    var theme = param.theme;
    return theme.colors.inputSecondary;
});
var FoldableText = function(_param) {
    var title = _param.title, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "title",
        "children"
    ]);
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
                justifyContent: "space-between",
                alignItems: "center",
                pb: "16px",
                onClick: function() {
                    return setIsExpanded(function(s) {
                        return !s;
                    });
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        fontWeight: "bold",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledExpandableLabelWrapper, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* .ExpandableLabel */ .L, {
                            expanded: isExpanded,
                            children: isExpanded ? t("Hide") : t("Details")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledChildrenFlex, {
                isExpanded: isExpanded,
                flexDirection: "column",
                children: children
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FoldableText);


/***/ }),

/***/ 6169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50308);
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _pancakeswap_wagmi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29315);
/* harmony import */ var _useCatchTxError__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76431);








var initialState = {
    approvalState: "idle",
    confirmState: "idle"
};
var reducer = function(state, actions) {
    switch(actions.type){
        case "approve_sending":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                approvalState: "loading"
            });
        case "approve_receipt":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                approvalState: "success"
            });
        case "approve_error":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                approvalState: "fail"
            });
        case "confirm_sending":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                confirmState: "loading"
            });
        case "confirm_receipt":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                confirmState: "success"
            });
        case "confirm_error":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                confirmState: "fail"
            });
        default:
            return state;
    }
};
var useApproveConfirmTransaction = function(param) {
    var onApprove = param.onApprove, onConfirm = param.onConfirm, onRequiresApproval = param.onRequiresApproval, _onSuccess = param.onSuccess, onSuccess = _onSuccess === void 0 ? (lodash_noop__WEBPACK_IMPORTED_MODULE_2___default()) : _onSuccess, _onApproveSuccess = param.onApproveSuccess, onApproveSuccess = _onApproveSuccess === void 0 ? (lodash_noop__WEBPACK_IMPORTED_MODULE_2___default()) : _onApproveSuccess;
    var account = (0,_pancakeswap_wagmi__WEBPACK_IMPORTED_MODULE_3__/* .useWeb3React */ .Ge)().account;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(reducer, initialState), state = ref[0], dispatch = ref[1];
    var handlePreApprove = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(onRequiresApproval);
    var fetchWithCatchTxError = (0,_useCatchTxError__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().fetchWithCatchTxError;
    var handleApprove = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var receipt;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchWithCatchTxError(function() {
                        dispatch({
                            type: "approve_sending"
                        });
                        return onApprove();
                    });
                case 2:
                    receipt = _ctx.sent;
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        dispatch({
                            type: "approve_receipt"
                        });
                        onApproveSuccess({
                            state: state,
                            receipt: receipt
                        });
                    } else {
                        dispatch({
                            type: "approve_error"
                        });
                    }
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        onApprove,
        onApproveSuccess,
        state,
        fetchWithCatchTxError
    ]);
    var handleConfirm = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var params, receipt, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    params = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                    _ctx.next = 3;
                    return fetchWithCatchTxError(function() {
                        dispatch({
                            type: "confirm_sending"
                        });
                        return onConfirm(params);
                    });
                case 3:
                    receipt = _ctx.sent;
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        dispatch({
                            type: "confirm_receipt"
                        });
                        onSuccess({
                            state: state,
                            receipt: receipt
                        });
                    } else {
                        dispatch({
                            type: "confirm_error"
                        });
                    }
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        onConfirm,
        dispatch,
        onSuccess,
        state,
        fetchWithCatchTxError
    ]);
    // Check if approval is necessary, re-check if account changes
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (account && handlePreApprove.current) {
            handlePreApprove.current().then(function(requiresApproval) {
                if (!requiresApproval) {
                    dispatch({
                        type: "approve_receipt"
                    });
                }
            });
        }
    }, [
        account,
        handlePreApprove,
        dispatch
    ]);
    return {
        isApproving: state.approvalState === "loading",
        isApproved: state.approvalState === "success",
        isConfirming: state.confirmState === "loading",
        isConfirmed: state.confirmState === "success",
        hasApproveFailed: state.approvalState === "fail",
        hasConfirmFailed: state.confirmState === "fail",
        handleApprove: handleApprove,
        handleConfirm: handleConfirm
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useApproveConfirmTransaction);


/***/ }),

/***/ 26902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ shadow_puppet; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var src = __webpack_require__(29315);
// EXTERNAL MODULE: ./src/config/abi/nftSale.json
var nftSale = __webpack_require__(3085);
// EXTERNAL MODULE: ./src/state/profile/hooks.ts + 9 modules
var hooks = __webpack_require__(11488);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(75943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(98553);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var localization_src = __webpack_require__(52775);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/views/PancakeSquad/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 100vh;\n  background-color: #e6feff;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1200px;\n  width: 100%;\n  margin: 0 16px;\n\n  ",
        " {\n    margin: 0 40px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 100%;\n\n  & > svg {\n    max-height: 16px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n    z-index: 5;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledSquadContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-3d6273d4-0"
})(_templateObject());
var LandingBodyWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-3d6273d4-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var StyledWaveContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-3d6273d4-2"
})(_templateObject2());

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Twitter.tsx
var Twitter = __webpack_require__(74167);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Instagram.tsx
var Instagram = __webpack_require__(66027);
;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/ArtistSection/config.tsx


var artistConfigBuilder = function(param) {
    var t = param.t, isDark = param.isDark;
    return {
        headingText: t("Meet the Artist"),
        bodyText: [
            t("Pixelwish, a design guru that specializes in the art of graphic design and visual communication,"),
            t("has set out to deliver the world of shadow puppets."),
            t("With his vast array of creative possibilities,"),
            t("He his determined to bring these Shadow creatures to life in a whole new way."),
            t("Utilizing cutting-edge 3D design techniques,"),
            t("he will craft each shadow puppet to be a one-of-a-kind masterpiece."),
            t("These NFTs will not just be digital assets, "),
            t("but true works of art that will be cherished for years to come."),
            t("Each creation will be authentic, rare and utility based"),
            t("giving them an added value to collectors."),
            t("With Pixelwish, the world of shadow puppets will never be the same."), 
        ],
        buttons: [
            {
                to: "https://twitter.com/Pixelwish_",
                text: t("Follow on Twitter"),
                external: true,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter/* default */.Z, {
                    color: "white"
                })
            },
            {
                to: "https://www.instagram.com/pixelwish_/",
                text: t("Follow on Instagram"),
                external: true,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Instagram/* default */.Z, {
                    color: "white"
                })
            }, 
        ],
        image: {
            src: "/images/pancakeSquad/artist".concat(isDark ? "-dark" : "", ".png"),
            alt: "Shadow pixelwish bio"
        }
    };
};
/* harmony default export */ var config = (artistConfigBuilder);

// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(98768);
;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/ArtistSection/styles.tsx

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background: ",
        ";\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 48px 36px;\n  border-radius: 56px;\n  background: ",
        ";\n  box-shadow: ",
        ";\n\n  & > svg {\n    position: absolute;\n    width: 20px;\n    height: 85px;\n    left: calc(50% - 10px);\n    top: -51px;\n    transform: rotate(90deg);\n\n    ",
        " {\n      left: -19px;\n      top: calc(50% - 42px);\n      transform: none;\n    }\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  ",
        " {\n    width: fit-content;\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledArtistSectionContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-6a38bf73-0"
})(styles_templateObject(), function(param) {
    var $isDark = param.$isDark;
    return $isDark ? "linear-gradient(90deg, #313D5C 0%, #3D2A54 100%);" : "linear-gradient(90deg, #faf9fa 0%, #d7caec 100%);";
});
var StyledArtistBioContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-6a38bf73-1"
})(styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.invertedContrast;
}, function(param) {
    var theme = param.theme;
    return theme.shadows.level1;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var StyledSocialButton = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-6a38bf73-2"
})(styles_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(44976);
;// CONCATENATED MODULE: ./src/views/PancakeSquad/assets/ArtistBottomWave.tsx






var Icon = function(_param) {
    var isDark = _param.isDark, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isDark"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 1280 17",
        preserveAspectRatio: "none"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0 16.002v-16c159.43 9.206 387.163 14.966 640 14.966s480.57-5.76 640-14.966v16H0z",
            fill: isDark ? "#08060B" : "#FAF9FA"
        })
    }));
};
/* harmony default export */ var ArtistBottomWave = (Icon);

;// CONCATENATED MODULE: ./src/views/PancakeSquad/assets/TriangleBio.tsx






var TriangleBio_Icon = function(_param) {
    var isDark = _param.isDark, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isDark"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 21 47",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1.416 24.914L17.66 41.157a8 8 0 012.343 5.657V.186a8 8 0 01-2.343 5.657L1.416 22.086a2 2 0 000 2.828z",
            fill: isDark ? "#000" : "#fff"
        })
    }));
};
/* harmony default export */ var TriangleBio = (TriangleBio_Icon);

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/ArtistSection/index.tsx









var ArtistSection = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var isDark = (0,styled_components_browser_esm/* useTheme */.Fg)().isDark;
    var ref = config({
        t: t,
        isDark: isDark
    }), headingText = ref.headingText, bodyText = ref.bodyText, buttons = ref.buttons, image = ref.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledArtistSectionContainer, {
        $isDark: isDark,
        justifyContent: [
            "flex-start",
            null,
            null,
            "center"
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LandingBodyWrapper, {
                py: [
                    "64px",
                    null,
                    null,
                    "100px"
                ],
                alignItems: [
                    "center"
                ],
                flexDirection: [
                    "column",
                    null,
                    null,
                    "row"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mb: [
                            "24px",
                            null,
                            null,
                            "-3px"
                        ],
                        maxWidth: [
                            "192px",
                            null,
                            "250px",
                            "100%"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: image.src,
                            alt: image.alt
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        ml: [
                            null,
                            null,
                            null,
                            "64px"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledArtistBioContainer, {
                                maxWidth: "550px",
                                flexDirection: "column",
                                alignSelf: [
                                    "flex-start",
                                    null,
                                    null,
                                    "center"
                                ],
                                mb: "40px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        fontSize: "40px",
                                        mr: "4px",
                                        bold: true,
                                        children: [
                                            "".concat(headingText, ", "),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                as: "span",
                                                fontSize: "40px",
                                                color: "secondary",
                                                bold: true,
                                                children: "Shadow Pixelwish"
                                            })
                                        ]
                                    }),
                                    bodyText.map(function(text) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "textSubtle",
                                            children: text
                                        }, text);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TriangleBio, {
                                        isDark: isDark
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                flexDirection: [
                                    "column",
                                    null,
                                    null,
                                    "row"
                                ],
                                justifyContent: [
                                    "center",
                                    null,
                                    null,
                                    "flex-start"
                                ],
                                alignItems: "center",
                                mx: [
                                    "10%",
                                    null,
                                    null,
                                    "0"
                                ],
                                children: buttons.map(function(button) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSocialButton, {
                                        mb: [
                                            "16px",
                                            null,
                                            null,
                                            "0"
                                        ],
                                        mr: [
                                            "0",
                                            null,
                                            null,
                                            "16px"
                                        ],
                                        external: button.external,
                                        href: button.to,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            width: "100%",
                                            startIcon: button.icon,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: "card",
                                                bold: true,
                                                fontSize: "16px",
                                                children: button.text
                                            })
                                        })
                                    }, button.text);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWaveContainer, {
                bottom: "-3px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistBottomWave, {
                    isDark: isDark
                })
            })
        ]
    });
};
/* harmony default export */ var components_ArtistSection = (ArtistSection);

// EXTERNAL MODULE: ./src/components/NextLink.tsx
var NextLink = __webpack_require__(12966);
// EXTERNAL MODULE: ./src/views/Home/components/ColoredWordHeading.tsx
var ColoredWordHeading = __webpack_require__(51063);
;// CONCATENATED MODULE: ./src/views/Home/components/SlideSvg.tsx




var SlideSvgLight = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 1660 339"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M804 167.023C520.5 167.023 267.5 290.522 0 304.5V339H1660V0.5C1358.83 0.5 1104 167.023 804 167.023Z",
                fill: "url(#paint0_linear_light)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_light",
                    x1: "830",
                    y1: "84",
                    x2: "830",
                    y2: "339",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "white",
                            stopOpacity: "0.48"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.566389",
                            stopColor: "white",
                            stopOpacity: "0.35"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            stopColor: "white"
                        })
                    ]
                })
            })
        ]
    }));
};
var SlideSvgDark = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 1660 339"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M804 166.523C520.5 166.523 267.5 290.022 0 304V338.5H1660V0C1358.83 0 1104 166.523 804 166.523Z",
                fill: "url(#paint0_linear_dark)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_dark",
                    x1: "830",
                    y1: "83.5",
                    x2: "830",
                    y2: "338.5",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#08060B",
                            stopOpacity: "0.2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.545554",
                            stopColor: "#08060B",
                            stopOpacity: "0.5"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            stopColor: "#08060B"
                        })
                    ]
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(63850);
;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/BunniesSection/config.ts
var bunniesConfig = function(t) {
    return {
        headingText: t("10,000 puppets."),
        subHeadingText: t("ZERO duplicates."),
        bodyText: [
            t("Every Shadow Puppet is Unique."),
            t("The Puppets Comes In Diffrent Class, Pirates, Magicians and more to be released from the Shadows with alots of Traits for each class."),
            t("Note: This preview will be slightly diffrent when the NFTs Arrive"), 
        ],
        primaryButton: {
            to: "/NotFound",
            text: t("View in Market")
        },
        images: {
            basePath: "/images/pancakeSquad/bunnies/bunny",
            alt: "bunny nft"
        }
    };
};
/* harmony default export */ var BunniesSection_config = (bunniesConfig);

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/BunniesSection/styles.tsx

function BunniesSection_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background: ",
        ";\n"
    ]);
    BunniesSection_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BunniesSection_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position:relative;\n  z-index: 5;\n  flex-shrink: 0;\n\n  & > img {\n    position absolute;\n    height: 100%;\n    top: 0;\n    left: 0;\n    transition: opacity 0.5s ease-in-out;\n  }\n"
    ]);
    BunniesSection_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BunniesSection_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  opacity: ",
        ";\n"
    ]);
    BunniesSection_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 5;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledBunnySectionContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-93892f2a-0"
})(BunniesSection_styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gradientBubblegum;
});
var StyledImageContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-93892f2a-1"
})(BunniesSection_styles_templateObject1());
var StyledBunnyImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-93892f2a-2"
})(BunniesSection_styles_templateObject2(), function(param) {
    var $isSelected = param.$isSelected;
    return $isSelected ? 1 : 0;
});
var StyledTextContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-93892f2a-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/BunniesSection/BunniesImages.tsx
/* eslint-disable react/no-array-index-key */ 


var BUNNIES_CYCLING_TIME = 2500;
var BunniesImages = function(param) {
    var basePath = param.basePath, altText = param.altText;
    var bunnies = new Array(11).fill({});
    var ref = (0,react.useState)(0), selectedBunny = ref[0], setSelectedBunny = ref[1];
    (0,react.useEffect)(function() {
        var timeoutId = setTimeout(function() {
            setSelectedBunny((selectedBunny + 1) % 5);
        }, BUNNIES_CYCLING_TIME);
        return function() {
            return clearTimeout(timeoutId);
        };
    }, [
        selectedBunny
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImageContainer, {
        mb: [
            "24px",
            null,
            null,
            "-3px"
        ],
        mr: [
            "0",
            null,
            null,
            "64px"
        ],
        width: [
            "192px",
            null,
            "250px",
            "400px",
            "512px"
        ],
        height: [
            "192px",
            null,
            "250px",
            "400px",
            "512px"
        ],
        children: bunnies.map(function(_, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBunnyImage, {
                $isSelected: index === selectedBunny,
                src: "".concat(basePath).concat(index, ".png"),
                alt: "".concat(altText, " example ").concat(index)
            }, index);
        })
    });
};
/* harmony default export */ var BunniesSection_BunniesImages = (BunniesImages);

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/BunniesSection/index.tsx











var BunniesSection = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var isDark = (0,useTheme/* default */.ZP)().isDark;
    var ref = BunniesSection_config(t), headingText = ref.headingText, bodyText = ref.bodyText, subHeadingText = ref.subHeadingText, primaryButton = ref.primaryButton, images = ref.images;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBunnySectionContainer, {
        justifyContent: [
            "flex-start",
            null,
            null,
            "center"
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LandingBodyWrapper, {
                pb: [
                    "64px",
                    null,
                    null,
                    "0"
                ],
                pt: [
                    "64px",
                    null,
                    null,
                    "40px"
                ],
                alignItems: [
                    "flex-end",
                    null,
                    "center",
                    null
                ],
                flexDirection: [
                    "column",
                    null,
                    null,
                    "row"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BunniesSection_BunniesImages, {
                        basePath: images.basePath,
                        altText: images.alt
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTextContainer, {
                        flexDirection: "column",
                        alignSelf: [
                            "flex-start",
                            null,
                            null,
                            "center"
                        ],
                        width: [
                            "100%",
                            null,
                            null,
                            "50%"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ColoredWordHeading/* default */.Z, {
                                text: headingText,
                                color: "text",
                                mb: "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ColoredWordHeading/* default */.Z, {
                                text: subHeadingText,
                                color: "text",
                                firstColor: "failure"
                            }),
                            bodyText.map(function(text) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "textSubtle",
                                    mb: "20px",
                                    children: text
                                }, text);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                                    to: primaryButton.to,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "card",
                                            bold: true,
                                            fontSize: "16px",
                                            children: t(primaryButton.text)
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                position: "absolute",
                bottom: "-2px",
                width: "100%",
                children: isDark ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideSvgDark, {
                    width: "100%"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideSvgLight, {
                    width: "100%"
                })
            })
        ]
    });
};
/* harmony default export */ var components_BunniesSection = (BunniesSection);

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/EventDescriptionSection/config.tsx

var eventDescriptionConfigBuilder = function(param) {
    var t = param.t;
    return {
        headingText: t("Fair, Random, Rare"),
        subHeadingText: t("All Shadow Puppet NFTs are allocated to Shadow Ticket holders through a provably-fair system based on Switchboard at the time of minting."),
        bodyTextHeader: t("Out of the 10,000 total NFTs in the shadow,"),
        bodyText: [
            {
                id: 1,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: t("500 are available in the pre-sale More Information Later on)")
                })
            },
            {
                id: 2,
                content: t("200 are reserved by the team for community giveaways, etc;")
            },
            {
                id: 3,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: t("and the remaining NFTs can be minted by anyone")
                })
            }, 
        ],
        primaryButton: {
            to: "https://docs.pancakeswap.finance/",
            text: t("View Documentation"),
            external: true,
            isDisplayed: false
        },
        image: {
            src: "/images/pancakeSquad/moonBunny/body.png",
            alt: "moon bunny"
        },
        accessoriesImages: [
            {
                src: "/images/pancakeSquad/moonBunny/band.png",
                alt: "headband"
            },
            {
                src: "/images/pancakeSquad/moonBunny/cloth.png",
                alt: "cloth"
            },
            {
                src: "/images/pancakeSquad/moonBunny/glasses.png",
                alt: "glasses"
            },
            {
                src: "/images/pancakeSquad/moonBunny/pancake.png",
                alt: "pancake"
            }, 
        ]
    };
};
/* harmony default export */ var EventDescriptionSection_config = (eventDescriptionConfigBuilder);

// EXTERNAL MODULE: ./packages/uikit/src/theme/colors.ts
var colors = __webpack_require__(16557);
;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/EventDescriptionSection/styles.tsx

function EventDescriptionSection_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: translate(0,  0px);\n  }\n  50% {\n    transform: translate(-5px, -5px);\n  }\n  to {\n    transform: translate(0, 0px);\n  }  \n"
    ]);
    EventDescriptionSection_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventDescriptionSection_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n"
    ]);
    EventDescriptionSection_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventDescriptionSection_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-bottom: 24px;\n"
    ]);
    EventDescriptionSection_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 12px;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 100%;\n  height: 100%;\n\n  & :nth-child(1) {\n    animation: ",
        " 3.5s ease-in-out infinite;\n    animation-delay: 1s;\n  }\n\n  & :nth-child(2) {\n    animation: ",
        " 3.5s ease-in-out infinite;\n    animation-delay: 0.66s;\n  }\n\n  & :nth-child(3) {\n    animation: ",
        " 3.5s ease-in-out infinite;\n    animation-delay: 0.33s;\n  }\n\n  & :nth-child(4) {\n    animation: ",
        " 3.5s ease-in-out infinite;\n    animation-delay: 0s;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 5;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var flyingAnim = function() {
    return (0,styled_components_browser_esm/* keyframes */.F4)(EventDescriptionSection_styles_templateObject());
};
var StyledEventDescriptionSectionContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d635a490-0"
})(EventDescriptionSection_styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
var StyledBodyTextList = (0,styled_components_browser_esm/* default */.ZP)("ul").withConfig({
    componentId: "sc-d635a490-1"
})(EventDescriptionSection_styles_templateObject2(), colors/* lightColors.textSubtle */.C.textSubtle);
var StyledBodyTextElement = (0,styled_components_browser_esm/* default */.ZP)("li").withConfig({
    componentId: "sc-d635a490-2"
})(styles_templateObject3());
var StyledBunnyAccessoriesContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d635a490-3"
})(_templateObject4(), flyingAnim, flyingAnim, flyingAnim, flyingAnim);
var StyledBunnyAccessory = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-d635a490-4"
})(_templateObject5());

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/EventDescriptionSection/index.tsx






var EventDescriptionSection = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = EventDescriptionSection_config({
        t: t
    }), headingText = ref.headingText, subHeadingText = ref.subHeadingText, bodyTextHeader = ref.bodyTextHeader, bodyText = ref.bodyText, primaryButton = ref.primaryButton;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledEventDescriptionSectionContainer, {
        justifyContent: [
            "flex-start",
            null,
            null,
            "center"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingBodyWrapper, {
            alignItems: [
                "flex-end",
                null,
                "center",
                null
            ],
            flexDirection: [
                "column",
                null,
                null,
                "row"
            ],
            pt: [
                "64px",
                null,
                "104px"
            ],
            pb: "60px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flex: 1,
                order: [
                    2,
                    null,
                    null,
                    1
                ],
                flexDirection: "column",
                mr: [
                    null,
                    null,
                    null,
                    "64px"
                ],
                alignSelf: [
                    "flex-start",
                    null,
                    null,
                    "center"
                ],
                width: [
                    "100%",
                    null,
                    null,
                    "50%"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "text",
                        fontSize: "40px",
                        mb: "24px",
                        bold: true,
                        children: headingText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        mb: "24px",
                        children: subHeadingText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        children: bodyTextHeader
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBodyTextList, {
                        children: bodyText.map(function(text) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBodyTextElement, {
                                children: text.content
                            }, text.id);
                        })
                    }),
                    (primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.isDisplayed) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            mr: "16px",
                            external: primaryButton.external,
                            href: primaryButton.to,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "secondary",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "card",
                                    bold: true,
                                    fontSize: "16px",
                                    children: t(primaryButton.text)
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_EventDescriptionSection = (EventDescriptionSection);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./packages/uikit/src/components/Stepper/Stepper.tsx
var Stepper = __webpack_require__(6999);
// EXTERNAL MODULE: ./packages/uikit/src/components/Stepper/Step.tsx
var Step = __webpack_require__(99018);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(20353);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(70257);
// EXTERNAL MODULE: ./src/hooks/useTokenBalance.ts
var useTokenBalance = __webpack_require__(94186);
;// CONCATENATED MODULE: ./src/views/PancakeSquad/assets/EventStepsBottomWave.tsx






var EventStepsBottomWave_Icon = function(_param) {
    var isDark = _param.isDark, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isDark"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        preserveAspectRatio: "none",
        viewBox: "0 0 1280 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 16.002V0.00195312C159.43 9.20767 387.163 14.9682 640 14.9682C892.837 14.9682 1120.57 9.20767 1280 0.00195312V16.002H0Z",
                fill: "url(#squad_event_steps_bottom_wave)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "squad_event_steps_bottom_wave",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: isDark ? "#313D5C" : "#FAF9FA"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            stopColor: isDark ? "#3D2A54" : "#d7caec"
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var EventStepsBottomWave = (EventStepsBottomWave_Icon);

;// CONCATENATED MODULE: ./src/views/PancakeSquad/assets/EventStepsTopWave.tsx






var EventStepsTopWave_Icon = function(_param) {
    var isDark = _param.isDark, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isDark"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 1280 17",
        preserveAspectRatio: "none"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0 16.002v-16c159.43 9.206 387.163 14.966 640 14.966s480.57-5.76 640-14.966v16H0z",
            fill: isDark ? "#0B4576" : "#70B7F2"
        })
    }));
};
/* harmony default export */ var EventStepsTopWave = (EventStepsTopWave_Icon);

;// CONCATENATED MODULE: ./src/views/PancakeSquad/types.ts
var SaleStatusEnum;
(function(SaleStatusEnum) {
    SaleStatusEnum[SaleStatusEnum["Pending"] = 0] = "Pending";
    SaleStatusEnum[SaleStatusEnum["Premint"] = 1] = "Premint";
    SaleStatusEnum[SaleStatusEnum["Presale"] = 2] = "Presale";
    SaleStatusEnum[SaleStatusEnum["Sale"] = 3] = "Sale";
    SaleStatusEnum[SaleStatusEnum["DrawingRandomness"] = 4] = "DrawingRandomness";
    SaleStatusEnum[SaleStatusEnum["Claim"] = 5] = "Claim";
})(SaleStatusEnum || (SaleStatusEnum = {}));
var UserStatusEnum;
(function(UserStatusEnum) {
    UserStatusEnum[UserStatusEnum["UNCONNECTED"] = 0] = "UNCONNECTED";
    UserStatusEnum[UserStatusEnum["NO_PROFILE"] = 1] = "NO_PROFILE";
    UserStatusEnum[UserStatusEnum["PROFILE_ACTIVE"] = 2] = "PROFILE_ACTIVE";
    UserStatusEnum[UserStatusEnum["PROFILE_ACTIVE_GEN0"] = 3] = "PROFILE_ACTIVE_GEN0";
})(UserStatusEnum || (UserStatusEnum = {}));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__(21046);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/ToastsContext/useToast.ts
var useToast = __webpack_require__(19237);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(21812);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 1 modules
var Toast = __webpack_require__(96036);
// EXTERNAL MODULE: ./src/hooks/useApproveConfirmTransaction.tsx
var useApproveConfirmTransaction = __webpack_require__(6169);
// EXTERNAL MODULE: ./src/hooks/useCallWithGasPrice.ts
var useCallWithGasPrice = __webpack_require__(85900);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(36963);
// EXTERNAL MODULE: ./src/utils/requiresApproval.ts
var requiresApproval = __webpack_require__(35831);
;// CONCATENATED MODULE: ./src/views/PancakeSquad/context.tsx

var PancakeSquadContext = /*#__PURE__*/ (0,react.createContext)({
    isUserEnabled: false,
    setIsUserEnabled: null
});

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Checkmark.tsx
var Checkmark = __webpack_require__(12851);
;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/Header/ReadyText.tsx





var ReadyText = function(_param) {
    var text = _param.text, props = (0,_object_without_properties/* default */.Z)(_param, [
        "text"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        alignItems: "center"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontSize: "16px",
                color: "success",
                mr: "4px",
                bold: true,
                children: text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkmark/* default */.Z, {
                color: "success",
                width: "17px"
            })
        ]
    }));
};
/* harmony default export */ var Header_ReadyText = (ReadyText);

// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/styles.tsx
var styles = __webpack_require__(15426);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(69589);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(89663);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Close.tsx
var Close = __webpack_require__(81641);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Info.tsx
var Info = __webpack_require__(95459);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(59123);
;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/Modals/BuyTickets/index.tsx
/* eslint-disable react/no-array-index-key */ 







var DEFAULT_MAX_PER_TX = 3;
var BuyTicketsModal = function(param) {
    var onDismiss = param.onDismiss, buyTicketCallBack = param.buyTicketCallBack, title = param.title, headerBackground = param.headerBackground, saleStatus = param.saleStatus, cakeBalance = param.cakeBalance, pricePerTicket = param.pricePerTicket, maxPerAddress = param.maxPerAddress, maxPerTransaction = param.maxPerTransaction, numberTicketsForGen0 = param.numberTicketsForGen0, numberTicketsOfUser = param.numberTicketsOfUser, numberTicketsUsedForGen0 = param.numberTicketsUsedForGen0;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ref = (0,react.useState)(1), ticketsNumber = ref[0], setTicketsNumber = ref[1];
    var isPreSale = saleStatus === SaleStatusEnum.Presale;
    var remainingTickets = isPreSale ? numberTicketsForGen0 : maxPerAddress - (numberTicketsOfUser - numberTicketsUsedForGen0);
    var isCakeBalanceInsufficient = cakeBalance.lt(pricePerTicket);
    var maxBuyTickets = Math.min(cakeBalance.div(pricePerTicket).toNumber(), remainingTickets);
    var totalCost = pricePerTicket.mul(bignumber/* BigNumber.from */.O$.from(ticketsNumber));
    var maxBuyButtons = saleStatus === SaleStatusEnum.Presale ? Math.min(numberTicketsForGen0, DEFAULT_MAX_PER_TX) : Math.min(maxPerTransaction, DEFAULT_MAX_PER_TX);
    var buyButtons = new Array(maxBuyButtons).fill("");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalContainer */.F0, {
        $minWidth: "375px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalHeader */.xB, {
                background: headerBackground,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalTitle */.r6, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        variant: "text",
                        onClick: onDismiss,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                            width: "24px",
                            color: "text"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalBody */.fe, {
                py: "24px",
                maxWidth: "375px",
                width: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            px: "16px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    textTransform: "uppercase",
                                    color: "secondary",
                                    mb: "16px",
                                    children: t("Buy how many?")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                    justifyContent: "space-evenly",
                                    mb: "24px",
                                    children: buyButtons.map(function(_, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: index + 1 === ticketsNumber ? "primary" : "tertiary",
                                            onClick: function() {
                                                return setTicketsNumber(index + 1);
                                            },
                                            disabled: index + 1 > maxBuyTickets,
                                            children: index + 1
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    mb: "8px",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            "font-size": "14px",
                                            color: "textSubtle",
                                            children: t("Cost per Ticket")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            "font-size": "14px",
                                            children: [
                                                (0,formatBalance/* formatBigNumber */.dp)(pricePerTicket, 0),
                                                " CAKE"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    mb: "8px",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            "font-size": "14px",
                                            color: "textSubtle",
                                            children: t("Your CORE Balance")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            "font-size": "14px",
                                            color: isCakeBalanceInsufficient ? "failure" : "text",
                                            children: [
                                                (0,formatBalance/* formatBigNumber */.dp)(cakeBalance, 3),
                                                " CORE"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    mb: "8px",
                                    pb: "8px",
                                    justifyContent: "space-between",
                                    "font-size": "14px",
                                    color: "textSubtle",
                                    borderBottom: "1px solid ".concat(theme.colors.cardBorder),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            "font-size": "14px",
                                            color: "textSubtle",
                                            children: t("Your remaining limit")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            "font-size": "14px",
                                            children: "".concat(remainingTickets, " ").concat(t("Tickets"))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    mb: "25px",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            "font-size": "14px",
                                            color: "textSubtle",
                                            children: t("Total Cost")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            "font-size": "14px",
                                            bold: true,
                                            children: [
                                                (0,formatBalance/* formatBigNumber */.dp)(totalCost, 0),
                                                " CORE"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            px: "16px",
                            py: "24px",
                            mb: "16px",
                            background: theme.colors.background,
                            borderBottom: "1px solid ".concat(theme.colors.cardBorder),
                            borderTop: "1px solid ".concat(theme.colors.cardBorder),
                            alignItems: "start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                        width: "20px",
                                        mt: "4px",
                                        mr: "10px",
                                        color: "textSubtle"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            "font-size": "12px",
                                            color: "textSubtle",
                                            mb: "12px",
                                            children: t("The network may become busy during the sale period. Consider setting a high gas fee (GWEI).")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            "font-size": "12px",
                                            color: "textSubtle",
                                            children: [
                                                t("Max. Tickets per transaction:"),
                                                " ",
                                                maxPerTransaction || DEFAULT_MAX_PER_TX
                                            ]
                                        }),
                                        maxPerAddress > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            "font-size": "12px",
                                            color: "textSubtle",
                                            children: [
                                                t("Max. Tickets per wallet:"),
                                                " ",
                                                maxPerAddress
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            px: "16px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                disabled: isCakeBalanceInsufficient,
                                onClick: function() {
                                    return buyTicketCallBack({
                                        ticketsNumber: ticketsNumber
                                    });
                                },
                                width: "100%",
                                children: isCakeBalanceInsufficient ? t("Insufficient Balance") : t("Confirm")
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var BuyTickets = (BuyTicketsModal);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowUp.tsx
var ArrowUp = __webpack_require__(40696);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(40735);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./packages/utils/truncateHash.ts
var truncateHash = __webpack_require__(15260);
;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/Modals/Confirm/index.tsx
/* eslint-disable react/no-array-index-key */ 






var ConfirmModal = function(param) {
    var onDismiss = param.onDismiss, onConfirmClose = param.onConfirmClose, title = param.title, isLoading = param.isLoading, headerBackground = param.headerBackground, txHash = param.txHash, loadingText = param.loadingText, loadingButtonLabel = param.loadingButtonLabel, successButtonLabel = param.successButtonLabel;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var onCloseCallback = function() {
        onConfirmClose();
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalContainer */.F0, {
        $minWidth: "375px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalHeader */.xB, {
                background: headerBackground,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalTitle */.r6, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        variant: "text",
                        onClick: onCloseCallback,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                            width: "24px",
                            color: "text"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalBody */.fe, {
                py: "24px",
                maxWidth: "375px",
                width: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    flexDirection: "column",
                    alignItems: "center",
                    children: isLoading || !txHash ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        px: "16px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                mb: "16px",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        mr: "16px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                fontSize: "20px",
                                                bold: true,
                                                color: "secondary",
                                                children: title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                fontSize: "14px",
                                                color: "textSubtle",
                                                children: loadingText
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/ShadowSwap.gif",
                                        alt: "Shadowswap",
                                        className: "Shadow-Gif",
                                        width: "200px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                width: "100%",
                                variant: "secondary",
                                disabled: true,
                                children: loadingButtonLabel
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUp/* default */.Z, {
                                width: "60px",
                                mb: "30px",
                                color: "primary"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mb: "30px",
                                bold: true,
                                children: t("Transaction Submitted")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkExternal/* default */.Z, {
                                href: (0,utils/* getBlockExploreLink */.C)(txHash, "transaction", chainId),
                                mb: "30px",
                                children: [
                                    t("View on CoreScan"),
                                    ": ",
                                    (0,truncateHash/* default */.Z)(txHash, 8, 0)
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                justifyContent: "center",
                                width: "100%",
                                px: "16px",
                                pt: "16px",
                                borderTop: "1px solid ".concat(theme.colors.cardBorder),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    width: "100%",
                                    variant: "secondary",
                                    onClick: onCloseCallback,
                                    children: successButtonLabel
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Confirm = (ConfirmModal);

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/Buttons/types.ts
var BuyButtonsEnum;
(function(BuyButtonsEnum) {
    BuyButtonsEnum[BuyButtonsEnum["ENABLE"] = 0] = "ENABLE";
    BuyButtonsEnum[BuyButtonsEnum["BUY"] = 1] = "BUY";
    BuyButtonsEnum[BuyButtonsEnum["READY"] = 2] = "READY";
    BuyButtonsEnum[BuyButtonsEnum["NONE"] = 3] = "NONE";
})(BuyButtonsEnum || (BuyButtonsEnum = {}));

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/Buttons/utils.ts


var getBuyButtonText = function(param) {
    var t = param.t, canBuyTickets = param.canBuyTickets, saleStatus = param.saleStatus, numberTicketsOfUser = param.numberTicketsOfUser;
    if ((saleStatus === SaleStatusEnum.Presale || saleStatus === SaleStatusEnum.Sale) && !canBuyTickets) {
        if (numberTicketsOfUser > 0) {
            return saleStatus === SaleStatusEnum.Presale ? t("Presale max purchased") : t("Max purchased");
        }
        return t("Not eligible");
    }
    return t("Buy Tickets");
};
var FIFTEEN_MINUTES = 60 * 15;
var getBuyButton = function(param) {
    var isApproved = param.isApproved, isGen0User = param.isGen0User, saleStatus = param.saleStatus, startTimestamp = param.startTimestamp, isUserReady = param.isUserReady, numberTicketsUsedForGen0 = param.numberTicketsUsedForGen0;
    var now = Date.now();
    if (!isApproved) return BuyButtonsEnum.ENABLE;
    if (isUserReady) return BuyButtonsEnum.READY;
    if (saleStatus === SaleStatusEnum.Presale && (isGen0User || numberTicketsUsedForGen0 > 0) && now < startTimestamp - FIFTEEN_MINUTES * 1000 || saleStatus === SaleStatusEnum.Sale && now >= startTimestamp) return BuyButtonsEnum.BUY;
    return BuyButtonsEnum.NONE;
};

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/Buttons/BuyTickets.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 


















var BuyTicketsButtons = function(param) {
    var t = param.t, account = param.account, saleStatus = param.saleStatus, userStatus = param.userStatus, theme = param.theme, canClaimForGen0 = param.canClaimForGen0, maxPerAddress = param.maxPerAddress, maxPerTransaction = param.maxPerTransaction, numberTicketsOfUser = param.numberTicketsOfUser, numberTicketsForGen0 = param.numberTicketsForGen0, numberTicketsUsedForGen0 = param.numberTicketsUsedForGen0, cakeBalance = param.cakeBalance, pricePerTicket = param.pricePerTicket, startTimestamp = param.startTimestamp;
    var ref = (0,react.useState)(null), txHashEnablingResult = ref[0], setTxHashEnablingResult = ref[1];
    var ref1 = (0,react.useState)(null), txHashBuyingResult = ref1[0], setTxHashBuyingResult = ref1[1];
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var nftSaleContract = (0,useContract/* useNftSaleContract */.Gj)();
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var ref2 = (0,useContract/* useCake */.kL)(), cakeContractReader = ref2.reader, cakeContractApprover = ref2.signer;
    var ref3 = (0,react.useContext)(PancakeSquadContext), isUserEnabled = ref3.isUserEnabled, setIsUserEnabled = ref3.setIsUserEnabled;
    var canBuySaleTicket = saleStatus === SaleStatusEnum.Sale && numberTicketsOfUser - numberTicketsUsedForGen0 < maxPerAddress;
    var isPreSale = saleStatus === SaleStatusEnum.Presale;
    var isGen0User = userStatus === UserStatusEnum.PROFILE_ACTIVE_GEN0;
    var isUserReady = userStatus === UserStatusEnum.PROFILE_ACTIVE && saleStatus < SaleStatusEnum.Sale || isGen0User && saleStatus === SaleStatusEnum.Pending;
    var ref4 = (0,useApproveConfirmTransaction/* default */.Z)({
        onRequiresApproval: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", (0,requiresApproval/* requiresApproval */.S)(cakeContractReader, account, nftSaleContract.address));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        onApprove: function() {
            return callWithGasPrice(cakeContractApprover, "approve", [
                nftSaleContract.address,
                bignumbers/* MaxUint256 */.Bz
            ]);
        },
        onApproveSuccess: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var receipt;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            receipt = param.receipt;
                            toastSuccess(t("Transaction has succeeded!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                txHash: receipt.transactionHash
                            }));
                            setTxHashEnablingResult(receipt.transactionHash);
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        onConfirm: function(param) {
            var ticketsNumber = param.ticketsNumber;
            onPresentConfirmModal();
            return callWithGasPrice(nftSaleContract, isPreSale ? "buyTicketsInPreSaleForGen0" : "buyTickets", [
                ticketsNumber, 
            ]);
        },
        onSuccess: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var receipt;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            receipt = param.receipt;
                            toastSuccess(t("Transaction has succeeded!"));
                            setTxHashBuyingResult(receipt.transactionHash);
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }()
    }), isApproving = ref4.isApproving, isApproved = ref4.isApproved, isConfirming = ref4.isConfirming, handleApprove = ref4.handleApprove, handleConfirm = ref4.handleConfirm, hasApproveFailed = ref4.hasApproveFailed, hasConfirmFailed = ref4.hasConfirmFailed;
    var onConfirmClose = function() {
        setTxHashBuyingResult(null);
    };
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Confirm, {
        title: t("Confirm"),
        isLoading: isConfirming,
        headerBackground: theme.colors.gradientCardHeader,
        txHash: txHashBuyingResult,
        loadingText: t("Please confirm your transaction in wallet."),
        loadingButtonLabel: t("Confirming..."),
        successButtonLabel: t("Close"),
        onConfirmClose: onConfirmClose
    }), false), 1), onPresentConfirmModal = ref5[0];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Confirm, {
        title: t("Enable"),
        isLoading: isApproving,
        headerBackground: theme.colors.gradientCardHeader,
        txHash: txHashEnablingResult,
        loadingText: t("Please enable CAKE spending in your wallet"),
        loadingButtonLabel: t("Enabling..."),
        successButtonLabel: t("Close"),
        onConfirmClose: onConfirmClose
    }), false), 2), onPresentEnableModal = ref6[0], onDismissEnableModal = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(BuyTickets, {
        title: t("Buy Minting Tickets"),
        buyTicketCallBack: handleConfirm,
        headerBackground: theme.colors.gradientCardHeader,
        cakeBalance: cakeBalance,
        maxPerAddress: maxPerAddress,
        maxPerTransaction: maxPerTransaction,
        numberTicketsForGen0: numberTicketsForGen0,
        numberTicketsOfUser: numberTicketsOfUser,
        numberTicketsUsedForGen0: numberTicketsUsedForGen0,
        pricePerTicket: pricePerTicket,
        saleStatus: saleStatus
    })), 2), onPresentBuyTicketsModal = ref7[0], onDismissBuyTicketsModal = ref7[1];
    (0,react.useEffect)(function() {
        return txHashEnablingResult && onPresentEnableModal();
    }, [
        txHashEnablingResult
    ]);
    (0,react.useEffect)(function() {
        return txHashBuyingResult && onPresentConfirmModal();
    }, [
        txHashBuyingResult
    ]);
    (0,react.useEffect)(function() {
        return hasApproveFailed && onDismissEnableModal();
    }, [
        hasApproveFailed
    ]);
    (0,react.useEffect)(function() {
        return hasConfirmFailed && onDismissBuyTicketsModal();
    }, [
        hasConfirmFailed
    ]);
    (0,react.useEffect)(function() {
        return isApproved && setIsUserEnabled && setIsUserEnabled(isApproved);
    }, [
        isApproved,
        setIsUserEnabled
    ]);
    var handleEnableClick = function() {
        onPresentEnableModal();
        handleApprove();
    };
    var canBuyTickets = (canClaimForGen0 || canBuySaleTicket) && isUserEnabled;
    var buyButton = getBuyButton({
        isApproved: isUserEnabled,
        isGen0User: isGen0User,
        saleStatus: saleStatus,
        startTimestamp: startTimestamp,
        isUserReady: isUserReady,
        numberTicketsUsedForGen0: numberTicketsUsedForGen0
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            buyButton === BuyButtonsEnum.ENABLE && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                width: "100%",
                onClick: handleEnableClick,
                children: t("Enable")
            }),
            buyButton === BuyButtonsEnum.READY && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_ReadyText, {
                text: isGen0User ? t("Ready for Pre-Sale!") : t("Ready for Public Sale!")
            }),
            buyButton === BuyButtonsEnum.BUY && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                width: "100%",
                onClick: onPresentBuyTicketsModal,
                disabled: !canBuyTickets,
                children: getBuyButtonText({
                    canBuyTickets: canBuyTickets,
                    numberTicketsOfUser: numberTicketsOfUser,
                    saleStatus: saleStatus,
                    t: t
                })
            })
        ]
    });
};
/* harmony default export */ var Buttons_BuyTickets = (BuyTicketsButtons);

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/Buttons/EndEvent.tsx




var EndEventButtons = function(param) {
    var t = param.t, account = param.account, saleStatus = param.saleStatus, numberTokensOfUser = param.numberTokensOfUser, maxSupply = param.maxSupply, totalSupplyMinted = param.totalSupplyMinted;
    var hasSquad = saleStatus === SaleStatusEnum.Claim && numberTokensOfUser > 0;
    var canViewMarket = maxSupply === totalSupplyMinted;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        flexDirection: [
            "column",
            null,
            null,
            "row"
        ],
        children: [
            canViewMarket && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                mb: [
                    "4px",
                    null,
                    null,
                    "0"
                ],
                mr: [
                    0,
                    null,
                    null,
                    "4px"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                    to: "/nfts",
                    children: t("View market")
                })
            }),
            hasSquad && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                    to: "/profile/".concat(account),
                    children: t("Your Squad (%tokens%)", {
                        tokens: numberTokensOfUser
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var EndEvent = (EndEventButtons);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(63771);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx
var useCatchTxError = __webpack_require__(76431);
;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/Buttons/Mint.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 










var MintButton = function(param) {
    var t = param.t, theme = param.theme, saleStatus = param.saleStatus, numberTicketsOfUser = param.numberTicketsOfUser, ticketsOfUser = param.ticketsOfUser;
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var nftSaleContract = (0,useContract/* useNftSaleContract */.Gj)();
    var ref = (0,react.useState)(null), txHashMintingResult = ref[0], setTxHashMintingResult = ref[1];
    var canMintTickets = saleStatus === SaleStatusEnum.Claim && numberTicketsOfUser > 0;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var ref1 = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref1.fetchWithCatchTxError, isLoading = ref1.loading;
    var onConfirmClose = function() {
        setTxHashMintingResult(null);
    };
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Confirm, {
        title: t("Mint"),
        isLoading: isLoading,
        headerBackground: theme.colors.gradientCardHeader,
        txHash: txHashMintingResult,
        loadingText: t("Please confirm your transaction in wallet."),
        loadingButtonLabel: t("Minting..."),
        successButtonLabel: t("Close"),
        onConfirmClose: onConfirmClose
    }), false), 2), onPresentConfirmModal = ref2[0], onDismiss = ref2[1];
    var mintTokenCallBack = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetchWithCatchTxError(function() {
                            return callWithGasPrice(nftSaleContract, "mint", [
                                ticketsOfUser
                            ]);
                        });
                    case 2:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess(t("Transaction has succeeded!"));
                            setTxHashMintingResult(receipt.transactionHash);
                        } else {
                            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function mintTokenCallBack() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        return txHashMintingResult && !isLoading && onPresentConfirmModal();
    }, [
        isLoading,
        txHashMintingResult
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: canMintTickets && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            width: "100%",
            onClick: mintTokenCallBack,
            disabled: isLoading,
            endIcon: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                spin: true,
                color: "currentColor"
            }) : undefined,
            children: t("Mint NFTs (%tickets%)", {
                tickets: numberTicketsOfUser
            })
        })
    });
};
/* harmony default export */ var Mint = (MintButton);

;// CONCATENATED MODULE: ./src/utils/formatTimePeriod.ts
/**
 * @param {Object} periods Return value from getTimePeriods
 * @param excludePeriods Key list for the object values of that exclude the periods
 * @return {string} '14h 3m 4s'
 */ var formatTimePeriod = function(periods) {
    var excludePeriods = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var textArr = [];
    Object.keys(periods).forEach(function(period) {
        if (periods[period] > 0 && !excludePeriods.includes(period)) {
            textArr.push("".concat(periods[period]).concat(period.substring(0, 1)));
        }
    });
    if (textArr.length === 0) {
        return null;
    }
    return textArr.join(" ");
};
/* harmony default export */ var utils_formatTimePeriod = (formatTimePeriod);

// EXTERNAL MODULE: ./src/utils/getTimePeriods.ts
var getTimePeriods = __webpack_require__(13471);
;// CONCATENATED MODULE: ./src/views/PancakeSquad/utils.ts



var utils_FIFTEEN_MINUTES = 60 * 15;
var PRESALE_TIMESTAMP = 1633579200000;
var getUserStatus = function(param) {
    var account = param.account, hasActiveProfile = param.hasActiveProfile, hasGen0 = param.hasGen0;
    if (account && hasActiveProfile && hasGen0) {
        return UserStatusEnum.PROFILE_ACTIVE_GEN0;
    }
    if (account && hasActiveProfile) {
        return UserStatusEnum.PROFILE_ACTIVE;
    }
    if (account) {
        return UserStatusEnum.NO_PROFILE;
    }
    return UserStatusEnum.UNCONNECTED;
};
var eventTextMapping = function(t, saleStatus) {
    switch(saleStatus){
        case SaleStatusEnum.Pending:
            return t("Get Ready");
        case SaleStatusEnum.Premint:
            return t("Get Ready");
        case SaleStatusEnum.Presale:
            return t("Presale");
        case SaleStatusEnum.Sale:
            return t("Public Sale");
        case SaleStatusEnum.DrawingRandomness:
            return t("Public Sale");
        case SaleStatusEnum.Claim:
            return t("Claim Phase");
        default:
            return "";
    }
};
var getEventStepStatus = function(param) {
    var eventStatus = param.eventStatus, saleStatus = param.saleStatus, startTimestamp = param.startTimestamp;
    var now = Date.now();
    if (eventStatus.every(function(status) {
        return status < saleStatus;
    })) return "past";
    if (eventStatus.some(function(status) {
        return status === saleStatus;
    })) {
        if (startTimestamp && saleStatus === SaleStatusEnum.Presale && now > startTimestamp - utils_FIFTEEN_MINUTES * 1000) {
            return "past";
        }
        return "live";
    }
    return "upcoming";
};
var getTimePeriodFromTimeStamp = function(param) {
    var startTimestamp = param.startTimestamp, _timestampOffsetInSeconds = param.timestampOffsetInSeconds, timestampOffsetInSeconds = _timestampOffsetInSeconds === void 0 ? 0 : _timestampOffsetInSeconds;
    if (!startTimestamp) return "";
    var nowInSeconds = Date.now() / 1000;
    var startTimestampInSeconds = startTimestamp / 1000 - timestampOffsetInSeconds;
    var timePeriods = (0,getTimePeriods/* default */.Z)(Math.round(startTimestampInSeconds - nowInSeconds));
    return utils_formatTimePeriod(timePeriods) || "0s";
};
var getEventText = function(param) {
    var eventStatus = param.eventStatus, saleStatus = param.saleStatus, startTimestamp = param.startTimestamp, t = param.t;
    var eventStepStatus = getEventStepStatus({
        eventStatus: eventStatus,
        saleStatus: saleStatus,
        startTimestamp: startTimestamp
    });
    if (eventStepStatus === "live" && saleStatus === SaleStatusEnum.DrawingRandomness) return "".concat(eventTextMapping(t, eventStatus[0]), ": ").concat(t("Sold Out!"));
    if (eventStepStatus === "live" && saleStatus > 0) {
        if (saleStatus === SaleStatusEnum.Presale) {
            return "".concat(eventTextMapping(t, eventStatus[0]), ": ").concat(t("end in"), " ").concat(getTimePeriodFromTimeStamp({
                startTimestamp: startTimestamp,
                timestampOffsetInSeconds: utils_FIFTEEN_MINUTES
            }));
        }
        if (saleStatus === SaleStatusEnum.DrawingRandomness) {
            return "".concat(eventTextMapping(t, eventStatus[0]), ": ").concat(t("Sold Out!"));
        }
        if (saleStatus > SaleStatusEnum.Premint) {
            return "".concat(eventTextMapping(t, eventStatus[0]), ": ").concat(t("Now Live"));
        }
    }
    if (eventStepStatus === "past" && eventStatus[0] === SaleStatusEnum.Presale) {
        return "".concat(eventTextMapping(t, eventStatus[0]), ": Closed");
    }
    if (eventStepStatus === "upcoming") {
        return "".concat(eventTextMapping(t, eventStatus[0]), ": ");
    }
    return eventTextMapping(t, eventStatus[0]);
};
var getAltText = function(param) {
    var startTimestamp = param.startTimestamp, eventStatus = param.eventStatus, saleStatus = param.saleStatus, t = param.t;
    var eventStepStatus = getEventStepStatus({
        eventStatus: eventStatus,
        saleStatus: saleStatus,
        startTimestamp: startTimestamp
    });
    if (saleStatus === SaleStatusEnum.DrawingRandomness && eventStepStatus === "upcoming") return t("Starting Soon");
    if (eventStepStatus === "upcoming" && eventStatus[0] === SaleStatusEnum.Presale) {
        return "".concat(t("starts in"), " ").concat(getTimePeriodFromTimeStamp({
            startTimestamp: PRESALE_TIMESTAMP
        }));
    }
    if (startTimestamp && eventStepStatus === "upcoming" && eventStatus[0] === SaleStatusEnum.Sale) {
        return "".concat(t("starts in"), " ").concat(getTimePeriodFromTimeStamp({
            startTimestamp: startTimestamp
        }));
    }
    return undefined;
};

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/EventStepsSection/utils.ts


var eventStatusMapping = {
    past: "past",
    live: "current",
    upcoming: "future"
};
var getStepperStatus = function(param) {
    var eventStatus = param.eventStatus, currentSaleStatus = param.saleStatus, hasProfileActivated = param.hasProfileActivated, _numberTicketsOfUser = param.numberTicketsOfUser, numberTicketsOfUser = _numberTicketsOfUser === void 0 ? 0 : _numberTicketsOfUser, _isLastPhase = param.isLastPhase, isLastPhase = _isLastPhase === void 0 ? false : _isLastPhase;
    if (!hasProfileActivated) return "future";
    if (currentSaleStatus === SaleStatusEnum.Claim && numberTicketsOfUser === 0 && !isLastPhase) return "past";
    var status = getEventStepStatus({
        saleStatus: currentSaleStatus,
        eventStatus: eventStatus
    });
    return eventStatusMapping[status];
};

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/EventStepsSection/config.tsx








var stepsConfigBuilder = function(param) {
    var t = param.t, userInfos = param.userInfos, eventInfos = param.eventInfos, userStatus = param.userStatus, account = param.account, theme = param.theme, cakeBalance = param.cakeBalance;
    var ref = eventInfos || {}, maxPerAddress = ref.maxPerAddress, maxPerTransaction = ref.maxPerTransaction, maxSupply = ref.maxSupply, pricePerTicket = ref.pricePerTicket;
    var ref1 = userInfos || {}, canClaimForGen0 = ref1.canClaimForGen0, ticketsOfUser = ref1.ticketsOfUser, numberTicketsUsedForGen0 = ref1.numberTicketsUsedForGen0, numberTicketsOfUser = ref1.numberTicketsOfUser, numberTicketsForGen0 = ref1.numberTicketsForGen0, numberTokensOfUser = ref1.numberTokensOfUser;
    var ref2 = eventInfos || {}, saleStatus = ref2.saleStatus, totalTicketsDistributed = ref2.totalTicketsDistributed, totalSupplyMinted = ref2.totalSupplyMinted, startTimestamp = ref2.startTimestamp;
    var hasProfileActivated = [
        UserStatusEnum.PROFILE_ACTIVE,
        UserStatusEnum.PROFILE_ACTIVE_GEN0
    ].includes(userStatus);
    var isBuyPhaseFinished = totalTicketsDistributed === maxSupply;
    var isMintingFinished = totalSupplyMinted === maxSupply;
    var hasData = !!eventInfos && !!userInfos;
    return [
        {
            id: 1,
            status: getStepperStatus({
                saleStatus: saleStatus,
                hasProfileActivated: hasProfileActivated,
                eventStatus: [
                    SaleStatusEnum.Pending,
                    SaleStatusEnum.Premint
                ]
            }),
            title: t("Hold CORE"),
            bodyText: [
                t("Each NFT costs CORE to mint. Remember you also need CORE to cover transaction fees too!")
            ],
            buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    as: "a",
                    href: "https://shadowswap.xyz/swap?outputCurrency=0xddBa66C1eBA873e26Ac0215Ca44892a07d83aDF5&chainId=1116",
                    target: "_blank",
                    width: "100%",
                    children: t("Buy CORE")
                })
            })
        },
        {
            id: 2,
            status: getStepperStatus({
                saleStatus: saleStatus,
                hasProfileActivated: hasProfileActivated,
                eventStatus: [
                    SaleStatusEnum.Presale,
                    SaleStatusEnum.Sale
                ]
            }),
            title: t("Buy Shadow Tickets"),
            bodyText: [
                t("Buy Shadow Tickets, while stocks last. You’ll use them in step 3."),
                "TBA ".concat(t("Pre-sale:500 NFTs will be avaliable for Pre-sale")),
                "TBA ".concat(t("Public Sale: Any wallet can purchase up to 10 Shadow Tickets, while stocks last.")), 
            ],
            buttons: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    hasData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons_BuyTickets, {
                        t: t,
                        account: account,
                        theme: theme,
                        userStatus: userStatus,
                        saleStatus: saleStatus,
                        canClaimForGen0: canClaimForGen0,
                        maxPerAddress: maxPerAddress,
                        numberTicketsOfUser: numberTicketsOfUser,
                        numberTicketsUsedForGen0: numberTicketsUsedForGen0,
                        cakeBalance: cakeBalance,
                        maxPerTransaction: maxPerTransaction,
                        numberTicketsForGen0: numberTicketsForGen0,
                        pricePerTicket: pricePerTicket,
                        startTimestamp: startTimestamp
                    }),
                    isBuyPhaseFinished && hasData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_ReadyText, {
                        mt: "16px",
                        text: t("Phase Complete!")
                    })
                ]
            })
        },
        {
            id: 3,
            status: getStepperStatus({
                saleStatus: saleStatus,
                hasProfileActivated: hasProfileActivated,
                eventStatus: [
                    SaleStatusEnum.Claim
                ],
                numberTicketsOfUser: numberTicketsOfUser
            }),
            title: t("Claim Phase"),
            bodyText: [
                t("During this phase, any wallet holding a Shadow Ticket can redeem their ticket to claim a Shadow Puppet NFT."), 
            ],
            buttons: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    hasData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Mint, {
                        t: t,
                        theme: theme,
                        saleStatus: saleStatus,
                        numberTicketsOfUser: numberTicketsOfUser,
                        numberTokensOfUser: numberTokensOfUser,
                        ticketsOfUser: ticketsOfUser
                    }),
                    isMintingFinished && hasData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_ReadyText, {
                        mt: "16px",
                        text: t("Phase Complete!")
                    })
                ]
            })
        },
        {
            id: 4,
            status: getStepperStatus({
                saleStatus: saleStatus,
                hasProfileActivated: hasProfileActivated,
                eventStatus: [
                    SaleStatusEnum.Claim
                ],
                isLastPhase: true
            }),
            title: t("Wait for the Reveal"),
            bodyText: [
                t("It’ll take a few days before your Puppet’s image is revealed. Just hold tight and wait for the final image!"),
                t("Trading will open before the images are live, but you’ll still be able to check the Puppets’ stats."), 
            ],
            buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: hasData && /*#__PURE__*/ (0,jsx_runtime.jsx)(EndEvent, {
                    t: t,
                    saleStatus: saleStatus,
                    userStatus: userStatus,
                    maxSupply: maxSupply,
                    totalSupplyMinted: totalSupplyMinted,
                    numberTokensOfUser: numberTokensOfUser,
                    account: account
                })
            })
        }, 
    ];
};
/* harmony default export */ var EventStepsSection_config = (stepsConfigBuilder);

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/EventStepsSection/styles.tsx

function EventStepsSection_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background: ",
        ";\n  z-index: 0;\n"
    ]);
    EventStepsSection_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventStepsSection_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 4px;\n"
    ]);
    EventStepsSection_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledEventStepsSectionContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-87433e50-0"
})(EventStepsSection_styles_templateObject(), function(param) {
    var $isDark = param.$isDark;
    return $isDark ? "linear-gradient(180deg, #0B4576 0%, #091115 100%)" : "linear-gradient(180deg, #6fb6f1 0%, #eaf2f6 100%)";
});
var StyledBunniesSquadImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-87433e50-1"
})(EventStepsSection_styles_templateObject1());

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/EventStepsSection/index.tsx











var EventStepsSection = function(param) {
    var eventInfos = param.eventInfos, userInfos = param.userInfos, isLoading = param.isLoading, userStatus = param.userStatus, account = param.account;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,useTheme/* default */.ZP)(), theme = ref.theme, isDark = ref.isDark;
    var ref1 = (0,useTokenBalance/* useGetCakeBalance */.Nn)(), cakeBalance = ref1.balance;
    var stepsConfig = EventStepsSection_config({
        t: t,
        eventInfos: eventInfos,
        userInfos: userInfos,
        userStatus: userStatus,
        account: account,
        theme: theme,
        cakeBalance: cakeBalance
    });
    var isMintingFinished = userInfos && eventInfos && eventInfos.maxSupply === eventInfos.totalSupplyMinted;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledEventStepsSectionContainer, {
        justifyContent: "center",
        $isDark: isDark,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWaveContainer, {
                top: "-13px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventStepsTopWave, {
                    isDark: isDark
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LandingBodyWrapper, {
                flexDirection: "column",
                alignItems: "center",
                py: "64px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "invertedContrast",
                        textAlign: "center",
                        fontSize: "40px",
                        mb: "64px",
                        bold: true,
                        children: t("Sounds great, how can I get one?")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mb: [
                            "80px",
                            null,
                            null,
                            "170px"
                        ],
                        children: isMintingFinished ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            flexDirection: "column",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "16px",
                                    color: "text",
                                    textAlign: "center",
                                    children: t("The minting period is now over: all 10,000 bunnies have now been minted.")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "16px",
                                    color: "text",
                                    textAlign: "center",
                                    mb: "64px",
                                    children: t("Head to the NFT Marketplace to buy!")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/nfts",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            as: "a",
                                            children: t("View market")
                                        })
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Stepper/* default */.Z, {
                            children: stepsConfig.map(function(step, index) {
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Step/* Step */.h, {
                                    index: index,
                                    statusFirstPart: step.status,
                                    statusSecondPart: (ref = stepsConfig[index + 1]) === null || ref === void 0 ? void 0 : ref.status,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBody/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                maxWidth: "388px",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        color: "secondary",
                                                        fontSize: "20px",
                                                        mb: "16px",
                                                        bold: true,
                                                        children: step.title
                                                    }),
                                                    step.bodyText.map(function(text) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            color: "textSubtle",
                                                            mb: "16px",
                                                            children: text
                                                        }, text);
                                                    }),
                                                    isLoading ? null : step.buttons
                                                ]
                                            })
                                        })
                                    })
                                }, step.id);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWaveContainer, {
                bottom: "-3px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventStepsBottomWave, {
                    isDark: isDark
                })
            })
        ]
    });
};
/* harmony default export */ var components_EventStepsSection = (EventStepsSection);

// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardHeader.tsx
var CardHeader = __webpack_require__(55209);
// EXTERNAL MODULE: ./src/components/FoldableSection/FoldableText.tsx
var FoldableText = __webpack_require__(95122);
;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/FaqSection/config.tsx


var config_config = function(param) {
    var t = param.t;
    return [
        {
            title: t("What’s the Smart Contract?"),
            description: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "textSubtle",
                    children: t("The smart contract address will be released soon before the sale starts.")
                }, 1), 
            ]
        },
        {
            title: t("I can’t see my NFT’s picture!"),
            description: [
                t("Wait for the reveal! After all 10,000 members of the Shadow Puppet have been minted, their images will remain hidden for a few days. Just be patient :)"), 
            ]
        },
        {
            title: t("How many can I mint?"),
            description: [
                t("The max limit per wallet is 10 NFTs."), 
            ]
        },
        {
            title: t("Where do the fees go?"),
            description: [
                t("Allocation of CORE spent on Shadow Puppet NFTs will be announed.")
            ]
        },
        {
            title: t("How are the NFTs randomly distributed?"),
            description: [
                t("Once all 10,000 Shadow Tickets have been bought, Switchboard VRF will be used to randomly allocate the pre-generated NFTs to the purchased Tickets. Shadow Tickets are allocated IDs numbered in order of their purchase."),
                t("Once all 10,000 have been sold, VRF will pick numbers from 0 to 9999, which will be used to shift the Shadow Ticket ID. This will ensure that the distribution of rare NFTs will be randomized, and prevents “sniping” of specific NFTs during the pre-sale or public sale phases."), 
            ]
        },
        {
            title: t("What’s the value of each NFT?"),
            description: [
                t("Value is subjective, but since different traits have different levels of rarity, you can expect Puppets with rarer traits to trade for higher prices than others. If you’re planning to sell, check the NFT market for the price of puppets with a similarly rare traits to yours."), 
            ]
        }, 
    ];
};
/* harmony default export */ var FaqSection_config = (config_config);

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/FaqSection/styles.tsx

function FaqSection_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background: ",
        ";\n"
    ]);
    FaqSection_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FaqSection_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  order: 1;\n  margin-bottom: 40px;\n\n  ",
        " {\n    order: 2;\n    margin-bottom: 0;\n    margin-left: 40px;\n  }\n"
    ]);
    FaqSection_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FaqSection_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    FaqSection_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledFaqSection = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5a32c1d4-0"
})(FaqSection_styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
var StyledDetailsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5a32c1d4-1"
})(FaqSection_styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var StyledLinkFAQs = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-5a32c1d4-2"
})(FaqSection_styles_templateObject2());

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/FaqSection/index.tsx







var FaqSection = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var config = FaqSection_config({
        t: t
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFaqSection, {
        justifyContent: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingBodyWrapper, {
            py: "64px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDetailsWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                scale: "lg",
                                color: "secondary",
                                children: t("FAQs")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBody/* default */.Z, {
                            children: config.map(function(param, i, param1) {
                                var title = param.title, description = param.description, length = param1.length;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FoldableText/* default */.Z, {
                                    id: title,
                                    mb: i + 1 === length ? "" : "24px",
                                    title: title,
                                    children: description.map(function(desc) {
                                        return typeof desc === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "textSubtle",
                                            as: "p",
                                            children: desc
                                        }, desc) : desc;
                                    })
                                }, title);
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var components_FaqSection = (FaqSection);

// EXTERNAL MODULE: ./packages/uikit/src/components/Timeline/Timeline.tsx + 2 modules
var Timeline = __webpack_require__(91714);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx + 1 modules
var ConnectWalletButton = __webpack_require__(72409);
;// CONCATENATED MODULE: ./src/views/PancakeSquad/assets/HeaderBottomWave.tsx






var HeaderBottomWave_Icon = function(_param) {
    var isDark = _param.isDark, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isDark"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 1280 16",
        preserveAspectRatio: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 16V0c159.43 9.206 387.163 14.966 640 14.966S1120.57 9.206 1280 0v16H0z",
                fill: "url(#squad_header_bottom_wave)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "squad_header_bottom_wave",
                    x1: 174.5,
                    y1: 15.999,
                    x2: 1233.5,
                    y2: 16,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: isDark ? "#313D5C" : "#E5FDFF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: 1,
                            stopColor: isDark ? "#3D2A54" : "#F3EFFF"
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var HeaderBottomWave = (HeaderBottomWave_Icon);

;// CONCATENATED MODULE: ./src/views/PancakeSquad/config.ts


var nftSaleConfigBuilder = function(param) {
    var t = param.t, saleStatus = param.saleStatus, startTimestamp = param.startTimestamp;
    return saleStatus !== undefined ? [
        {
            status: getEventStepStatus({
                saleStatus: saleStatus,
                eventStatus: [
                    SaleStatusEnum.Pending,
                    SaleStatusEnum.Premint
                ]
            }),
            text: getEventText({
                saleStatus: saleStatus,
                eventStatus: [
                    SaleStatusEnum.Pending,
                    SaleStatusEnum.Premint
                ],
                t: t
            }),
            infoText: t("Activate your profile and make sure you have at least the cost of 1 NFT in your wallet to buy a Squad Ticket.")
        },
        {
            status: getEventStepStatus({
                saleStatus: saleStatus,
                eventStatus: [
                    SaleStatusEnum.Presale
                ],
                startTimestamp: startTimestamp
            }),
            text: getEventText({
                saleStatus: saleStatus,
                eventStatus: [
                    SaleStatusEnum.Presale
                ],
                startTimestamp: startTimestamp,
                t: t
            }),
            altText: getAltText({
                t: t,
                saleStatus: saleStatus,
                eventStatus: [
                    SaleStatusEnum.Presale
                ],
                startTimestamp: startTimestamp
            }),
            infoText: t("Pre-sale: Wallets which held “Gen 0” Pancake Bunnies NFTs (bunnyID 0,1,2,3,4) at a snapshot taken some time between 12 and 2 hours before the presale begins can purchase one Squad Ticket per Gen 0 NFT.")
        },
        {
            status: getEventStepStatus({
                saleStatus: saleStatus,
                eventStatus: [
                    SaleStatusEnum.Sale,
                    SaleStatusEnum.DrawingRandomness
                ],
                startTimestamp: startTimestamp
            }),
            text: getEventText({
                saleStatus: saleStatus,
                startTimestamp: startTimestamp,
                eventStatus: [
                    SaleStatusEnum.Sale,
                    SaleStatusEnum.DrawingRandomness
                ],
                t: t
            }),
            altText: getAltText({
                t: t,
                saleStatus: saleStatus,
                eventStatus: [
                    SaleStatusEnum.Sale,
                    SaleStatusEnum.DrawingRandomness
                ],
                startTimestamp: startTimestamp
            }),
            infoText: t("Public Sale: Any wallet with an active Pancake Profile can purchase up to 10 Squad Tickets, while stocks last.")
        },
        {
            status: getEventStepStatus({
                saleStatus: saleStatus,
                eventStatus: [
                    SaleStatusEnum.Claim
                ]
            }),
            text: getEventText({
                saleStatus: saleStatus,
                eventStatus: [
                    SaleStatusEnum.Claim
                ],
                t: t
            }),
            altText: getAltText({
                t: t,
                saleStatus: saleStatus,
                eventStatus: [
                    SaleStatusEnum.Claim
                ]
            }),
            infoText: t("During this phase, any wallet holding a Squad Ticket can redeem their ticket to mint a Pancake Squad NFT.")
        }, 
    ] : [];
};
/* harmony default export */ var PancakeSquad_config = (nftSaleConfigBuilder);

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/Buttons/ActivateProfile.tsx




var ActivateProfileButton = function(param) {
    var t = param.t, userStatus = param.userStatus;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (userStatus === UserStatusEnum.NO_PROFILE || userStatus === UserStatusEnum.UNCONNECTED) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            as: NextLink/* NextLinkFromReactRouter */.a,
            to: "/create-profile",
            mr: "4px",
            children: t("Activate Profile")
        })
    });
};
/* harmony default export */ var ActivateProfile = (ActivateProfileButton);

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/Header/types.ts
var ButtonsEnum;
(function(ButtonsEnum) {
    ButtonsEnum[ButtonsEnum["ACTIVATE"] = 0] = "ACTIVATE";
    ButtonsEnum[ButtonsEnum["BUY"] = 1] = "BUY";
    ButtonsEnum[ButtonsEnum["MINT"] = 2] = "MINT";
    ButtonsEnum[ButtonsEnum["END"] = 3] = "END";
    ButtonsEnum[ButtonsEnum["NONE"] = 4] = "NONE";
})(ButtonsEnum || (ButtonsEnum = {}));

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/Header/utils.ts


var getCurrentButton = function(param) {
    var userStatus = param.userStatus, saleStatus = param.saleStatus, numberTicketsOfUser = param.numberTicketsOfUser;
    var isBuyingFinished = saleStatus > SaleStatusEnum.Sale;
    if (userStatus === UserStatusEnum.NO_PROFILE && !isBuyingFinished) return ButtonsEnum.ACTIVATE;
    if (saleStatus === SaleStatusEnum.Presale || saleStatus === SaleStatusEnum.Sale) return ButtonsEnum.BUY;
    if (saleStatus === SaleStatusEnum.Claim && numberTicketsOfUser > 0) return ButtonsEnum.MINT;
    if (saleStatus === SaleStatusEnum.Claim) return ButtonsEnum.END;
    return ButtonsEnum.NONE;
};

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/Header/CtaButtons.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 







var CtaButtons = function(param) {
    var t = param.t, account = param.account, saleStatus = param.saleStatus, userStatus = param.userStatus, theme = param.theme, canClaimForGen0 = param.canClaimForGen0, maxPerAddress = param.maxPerAddress, maxPerTransaction = param.maxPerTransaction, numberTicketsOfUser = param.numberTicketsOfUser, numberTicketsForGen0 = param.numberTicketsForGen0, numberTicketsUsedForGen0 = param.numberTicketsUsedForGen0, numberTokensOfUser = param.numberTokensOfUser, startTimestamp = param.startTimestamp, maxSupply = param.maxSupply, totalSupplyMinted = param.totalSupplyMinted, cakeBalance = param.cakeBalance, pricePerTicket = param.pricePerTicket, ticketsOfUser = param.ticketsOfUser;
    var buttonType = getCurrentButton({
        numberTicketsOfUser: numberTicketsOfUser,
        saleStatus: saleStatus,
        userStatus: userStatus
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            children: [
                buttonType === ButtonsEnum.ACTIVATE && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivateProfile, {
                    userStatus: userStatus,
                    t: t
                }),
                buttonType === ButtonsEnum.BUY && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons_BuyTickets, {
                    t: t,
                    account: account,
                    theme: theme,
                    userStatus: userStatus,
                    saleStatus: saleStatus,
                    canClaimForGen0: canClaimForGen0,
                    maxPerAddress: maxPerAddress,
                    numberTicketsOfUser: numberTicketsOfUser,
                    numberTicketsUsedForGen0: numberTicketsUsedForGen0,
                    cakeBalance: cakeBalance,
                    maxPerTransaction: maxPerTransaction,
                    numberTicketsForGen0: numberTicketsForGen0,
                    pricePerTicket: pricePerTicket,
                    startTimestamp: startTimestamp
                }),
                buttonType === ButtonsEnum.MINT && /*#__PURE__*/ (0,jsx_runtime.jsx)(Mint, {
                    t: t,
                    theme: theme,
                    saleStatus: saleStatus,
                    numberTicketsOfUser: numberTicketsOfUser,
                    numberTokensOfUser: numberTokensOfUser,
                    ticketsOfUser: ticketsOfUser
                }),
                buttonType === ButtonsEnum.END && /*#__PURE__*/ (0,jsx_runtime.jsx)(EndEvent, {
                    t: t,
                    account: account,
                    saleStatus: saleStatus,
                    userStatus: userStatus,
                    maxSupply: maxSupply,
                    totalSupplyMinted: totalSupplyMinted,
                    numberTokensOfUser: numberTokensOfUser
                })
            ]
        })
    });
};
/* harmony default export */ var Header_CtaButtons = (CtaButtons);

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/Header/MintText.tsx



var MintText = function(param) {
    var t = param.t, saleStatus = param.saleStatus, userStatus = param.userStatus, numberTicketsOfUser = param.numberTicketsOfUser, numberTokensOfUser = param.numberTokensOfUser;
    var isUserUnconnected = userStatus === UserStatusEnum.UNCONNECTED;
    var displayMintText = (userStatus === UserStatusEnum.PROFILE_ACTIVE_GEN0 || numberTicketsOfUser > 0) && saleStatus === SaleStatusEnum.Presale || saleStatus >= SaleStatusEnum.Sale;
    var hasNoTicketOrToken = numberTicketsOfUser === 0 && numberTokensOfUser === 0;
    return displayMintText ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        flexDirection: "column",
        mb: "24px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "16px",
                        color: colors/* lightColors.invertedContrast */.C.invertedContrast,
                        mr: "2px",
                        children: t("Your Claim Tickets: ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "16px",
                        color: numberTicketsOfUser > 0 ? colors/* lightColors.warning */.C.warning : colors/* lightColors.failure */.C.failure,
                        bold: true,
                        children: numberTicketsOfUser
                    })
                ]
            }),
            saleStatus === SaleStatusEnum.Claim && (isUserUnconnected || hasNoTicketOrToken) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                mt: "24px",
                fontSize: "16px",
                color: colors/* lightColors.warning */.C.warning,
                bold: true,
                children: isUserUnconnected ? t("Redeem Tickets to claim NFTs") : t("Sorry, you can’t claim any NFTs! Better luck next time.")
            })
        ]
    }) : null;
};
/* harmony default export */ var Header_MintText = (MintText);

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/Header/PreEventText.tsx



var preEventTextMapping = function(t, userStatus) {
    switch(userStatus){
        case UserStatusEnum.UNCONNECTED:
            return t("Are you ready?");
        case UserStatusEnum.NO_PROFILE:
            return t("You need a profile to participate!");
        case UserStatusEnum.PROFILE_ACTIVE:
            return t("You’re all set!");
        case UserStatusEnum.PROFILE_ACTIVE_GEN0:
            return t("You’re all set!");
        default:
            return "";
    }
};
var PreEventText = function(param) {
    var t = param.t, saleStatus = param.saleStatus, userStatus = param.userStatus;
    return [
        SaleStatusEnum.Pending,
        SaleStatusEnum.Premint
    ].includes(saleStatus) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        "data-theme": "dark",
        fontSize: "16px",
        color: "text",
        children: preEventTextMapping(t, userStatus)
    }) : null;
};
/* harmony default export */ var Header_PreEventText = (PreEventText);

// EXTERNAL MODULE: ./packages/uikit/src/components/Progress/Progress.tsx + 1 modules
var Progress = __webpack_require__(79207);
;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/Header/SaleProgress.tsx



var saleProgressTextMapping = function(t, saleStatus, remaining, total) {
    var data = {
        remaining: remaining,
        total: total
    };
    switch(saleStatus){
        case SaleStatusEnum.Pending:
        case SaleStatusEnum.Premint:
            return "";
        case SaleStatusEnum.Presale:
            return t("%remaining% of %total% remaining", data);
        case SaleStatusEnum.Sale:
            return t("%remaining% of %total% remaining", data);
        case SaleStatusEnum.DrawingRandomness:
            return t("Randomizing NFT allocation with Chainlink", data);
        case SaleStatusEnum.Claim:
            return t("%remaining% of %total% claimed", data);
        default:
            return "";
    }
};
var SaleProgress = function(param) {
    var t = param.t, saleStatus = param.saleStatus, totalTicketsDistributed = param.totalTicketsDistributed, totalSupplyMinted = param.totalSupplyMinted, maxSupply = param.maxSupply;
    var displaySaleProgress = saleStatus > SaleStatusEnum.Premint;
    var isClaimingPhase = saleStatus === SaleStatusEnum.Claim;
    var supplyRemaining = maxSupply - totalTicketsDistributed;
    var remainingTickets = isClaimingPhase ? totalSupplyMinted : supplyRemaining;
    var supplyRemainingPercentage = Math.round(remainingTickets / maxSupply * 100);
    var isMintCompleted = totalSupplyMinted === maxSupply && isClaimingPhase;
    return displaySaleProgress ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        mb: "24px",
        children: [
            isMintCompleted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: colors/* lightColors.warning */.C.warning,
                mb: "40px",
                bold: true,
                children: t("Claiming Complete!")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: colors/* lightColors.invertedContrast */.C.invertedContrast,
                mb: "24px",
                bold: true,
                children: isMintCompleted ? t("All 10,000 Shadow Puppet NFTs have now been minted!") : saleProgressTextMapping(t, saleStatus, remainingTickets.toString(), maxSupply.toString())
            }),
            !isMintCompleted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress/* default */.Z, {
                variant: "round",
                primaryStep: isClaimingPhase ? supplyRemainingPercentage : 100 - supplyRemainingPercentage,
                useDark: false
            })
        ]
    }) : null;
};
/* harmony default export */ var Header_SaleProgress = (SaleProgress);

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/Header/styles.tsx

function Header_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background: url('https://raw.githubusercontent.com/SVerseLab/images/master/longbox.png');\n          background-size: cover;\n          background-position: center;\n          background-width: 100%;\n          background-height: 100vh;\n"
    ]);
    Header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Header_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 40px;\n\n  ",
        " {\n    font-size: 64px;\n  }\n"
    ]);
    Header_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Header_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: linear-gradient(180deg, #53dee9 0%, #7645d9 100%);\n  border-radius: 32px;\n"
    ]);
    Header_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Header_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  background-clip: padding-box;\n  border-radius: inherit;\n"
    ]);
    Header_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledSquadHeaderContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d41cd005-0"
})(Header_styles_templateObject());
var StyledSquadTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-d41cd005-1"
})(Header_styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var StyledSquadEventBorder = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-d41cd005-2"
})(Header_styles_templateObject2());
var StyledSquadEventContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d41cd005-3"
})(Header_styles_templateObject3(), colors/* lightColors.text */.C.text);

;// CONCATENATED MODULE: ./src/views/PancakeSquad/components/Header/index.tsx















var DEFAULT_CAKE_COST = 0.00;
var DEFAULT_MAX_TICKETS = 10;
var PancakeSquadHeader = function(param) {
    var userInfos = param.userInfos, eventInfos = param.eventInfos, account = param.account, userStatus = param.userStatus, isLoading = param.isLoading;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,useTheme/* default */.ZP)(), theme = ref.theme, isDark = ref.isDark;
    var ref1 = (0,useTokenBalance/* useGetCakeBalance */.Nn)(), cakeBalance = ref1.balance;
    var displayEventBlock = !!eventInfos || isLoading;
    var ref2 = userInfos || {}, ticketsOfUser = ref2.ticketsOfUser, numberTicketsUsedForGen0 = ref2.numberTicketsUsedForGen0, numberTicketsOfUser = ref2.numberTicketsOfUser, numberTicketsForGen0 = ref2.numberTicketsForGen0, canClaimForGen0 = ref2.canClaimForGen0, numberTokensOfUser = ref2.numberTokensOfUser;
    var ref3 = eventInfos || {}, maxPerAddress = ref3.maxPerAddress, maxPerTransaction = ref3.maxPerTransaction, maxSupply = ref3.maxSupply, pricePerTicket = ref3.pricePerTicket, saleStatus = ref3.saleStatus, totalTicketsDistributed = ref3.totalTicketsDistributed, totalSupplyMinted = ref3.totalSupplyMinted, startTimestamp = ref3.startTimestamp;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSquadHeaderContainer, {
        pt: [
            "16px",
            null,
            null,
            "40px"
        ],
        px: [
            "16px",
            null,
            null,
            "80px"
        ],
        flexDirection: "column",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSquadTitle, {
                my: "32px",
                color: colors/* lightColors.primary */.C.primary,
                bold: true,
                textAlign: "center",
                children: t("Shadow Puppet")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: colors/* lightColors.warning */.C.warning,
                textAlign: "center",
                bold: true,
                children: "".concat(t("Presale:"), " To Be Announced")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: colors/* lightColors.warning */.C.warning,
                textAlign: "center",
                bold: true,
                children: "".concat(t("Public Sale:"), " To Be Announced")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: colors/* lightColors.warning */.C.warning,
                textAlign: "center",
                bold: true,
                children: t("Mint Cost: %minCost% CORE each", {
                    minCost: DEFAULT_CAKE_COST
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: colors/* lightColors.warning */.C.warning,
                textAlign: "center",
                bold: true,
                children: t("Max per wallet: %maxPerWallet%", {
                    maxPerWallet: DEFAULT_MAX_TICKETS
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: colors/* lightColors.warning */.C.warning,
                textAlign: "center",
                children: t("ShadowSwap’s first official Unique NFT collection coming soon.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: colors/* lightColors.warning */.C.warning,
                mb: !displayEventBlock ? "80px" : "32px",
                textAlign: "center",
                children: t("Join the shadows.")
            }),
            displayEventBlock && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSquadEventBorder, {
                mb: "56px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSquadEventContainer, {
                    m: "1px",
                    p: "32px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: [
                            "column",
                            null,
                            "row"
                        ],
                        children: [
                            eventInfos && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mr: [
                                    "0",
                                    null,
                                    null,
                                    "100px"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Timeline/* default */.Z, {
                                    events: PancakeSquad_config({
                                        t: t,
                                        saleStatus: saleStatus,
                                        startTimestamp: startTimestamp
                                    }),
                                    useDark: false
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexDirection: "column",
                                children: [
                                    eventInfos && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_PreEventText, {
                                                t: t,
                                                userStatus: userStatus,
                                                saleStatus: saleStatus
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_SaleProgress, {
                                                t: t,
                                                userStatus: userStatus,
                                                saleStatus: saleStatus,
                                                totalTicketsDistributed: totalTicketsDistributed,
                                                maxSupply: maxSupply,
                                                totalSupplyMinted: totalSupplyMinted
                                            }),
                                            userInfos && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_MintText, {
                                                t: t,
                                                userStatus: userStatus,
                                                saleStatus: saleStatus,
                                                numberTicketsOfUser: numberTicketsOfUser,
                                                numberTokensOfUser: numberTokensOfUser
                                            }),
                                            userInfos && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_CtaButtons, {
                                                t: t,
                                                account: account,
                                                theme: theme,
                                                userStatus: userStatus,
                                                saleStatus: saleStatus,
                                                numberTokensOfUser: numberTokensOfUser,
                                                canClaimForGen0: canClaimForGen0,
                                                maxPerAddress: maxPerAddress,
                                                maxSupply: maxSupply,
                                                numberTicketsOfUser: numberTicketsOfUser,
                                                numberTicketsUsedForGen0: numberTicketsUsedForGen0,
                                                totalSupplyMinted: totalSupplyMinted,
                                                cakeBalance: cakeBalance,
                                                maxPerTransaction: maxPerTransaction,
                                                numberTicketsForGen0: numberTicketsForGen0,
                                                pricePerTicket: pricePerTicket,
                                                ticketsOfUser: ticketsOfUser,
                                                startTimestamp: startTimestamp
                                            })
                                        ]
                                    }),
                                    isLoading && (userStatus === UserStatusEnum.UNCONNECTED ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/ShadowSwap.gif",
                                        alt: "Shadowswap",
                                        className: "Shadow-Gif"
                                    }))
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWaveContainer, {
                bottom: "-3px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBottomWave, {
                    isDark: isDark
                })
            })
        ]
    });
};
/* harmony default export */ var Header = (PancakeSquadHeader);

// EXTERNAL MODULE: ./src/utils/addressHelpers.ts + 1 modules
var addressHelpers = __webpack_require__(8414);
// EXTERNAL MODULE: ./src/utils/contractHelpers.ts + 29 modules
var contractHelpers = __webpack_require__(18380);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(9796);
;// CONCATENATED MODULE: ./src/views/PancakeSquad/hooks/useEventInfos.tsx









var useEventInfos = function(param) {
    var refreshCounter = param.refreshCounter, setCallback = param.setCallback;
    (0,react.useEffect)(function() {
        var fetchEventInfos = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var nftSaleAddress, pancakeSquadContract, calls, ref, ref1, currentMaxSupply, ref2, currentMaxPerAddress, ref3, currentPricePerTicket, ref4, currentMaxPerTransaction, ref5, currentTotalTicketsDistributed, ref6, currentSaleStatus, ref7, currentStartTimestamp, currentTotalSupplyMinted;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            nftSaleAddress = (0,addressHelpers/* getNftSaleAddress */.L$)();
                            pancakeSquadContract = (0,contractHelpers/* getPancakeSquadContract */.DR)();
                            calls = [
                                "maxSupply",
                                "maxPerAddress",
                                "pricePerTicket",
                                "maxPerTransaction",
                                "totalTicketsDistributed",
                                "currentStatus",
                                "startTimestamp", 
                            ].map(function(method) {
                                return {
                                    address: nftSaleAddress,
                                    name: method
                                };
                            });
                            _ctx.t0 = _sliced_to_array/* default */.Z;
                            _ctx.next = 7;
                            return (0,multicall/* multicallv2 */.v)({
                                abi: nftSale,
                                calls: calls
                            });
                        case 7:
                            _ctx.t1 = _ctx.sent;
                            ref = (0, _ctx.t0)(_ctx.t1, 7);
                            ref1 = (0,_sliced_to_array/* default */.Z)(ref[0], 1);
                            currentMaxSupply = ref1[0];
                            ref2 = (0,_sliced_to_array/* default */.Z)(ref[1], 1);
                            currentMaxPerAddress = ref2[0];
                            ref3 = (0,_sliced_to_array/* default */.Z)(ref[2], 1);
                            currentPricePerTicket = ref3[0];
                            ref4 = (0,_sliced_to_array/* default */.Z)(ref[3], 1);
                            currentMaxPerTransaction = ref4[0];
                            ref5 = (0,_sliced_to_array/* default */.Z)(ref[4], 1);
                            currentTotalTicketsDistributed = ref5[0];
                            ref6 = (0,_sliced_to_array/* default */.Z)(ref[5], 1);
                            currentSaleStatus = ref6[0];
                            ref7 = (0,_sliced_to_array/* default */.Z)(ref[6], 1);
                            currentStartTimestamp = ref7[0];
                            _ctx.next = 25;
                            return pancakeSquadContract.totalSupply();
                        case 25:
                            currentTotalSupplyMinted = _ctx.sent;
                            setCallback({
                                maxSupply: currentMaxSupply.toNumber(),
                                maxPerAddress: currentMaxPerAddress.toNumber(),
                                pricePerTicket: bignumber/* BigNumber.from */.O$.from(currentPricePerTicket),
                                maxPerTransaction: currentMaxPerTransaction.toNumber(),
                                totalTicketsDistributed: currentTotalTicketsDistributed.toNumber(),
                                saleStatus: currentSaleStatus,
                                startTimestamp: Number(currentStartTimestamp.toString().padEnd(13, "0")),
                                totalSupplyMinted: currentTotalSupplyMinted.toNumber()
                            });
                            _ctx.next = 32;
                            break;
                        case 29:
                            _ctx.prev = 29;
                            _ctx.t2 = _ctx["catch"](0);
                            console.error(_ctx.t2);
                        case 32:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        29
                    ]
                ]);
            }));
            return function fetchEventInfos() {
                return _ref.apply(this, arguments);
            };
        }();
        if (nftSale.length > 0) {
            fetchEventInfos();
        }
    }, [
        refreshCounter,
        setCallback
    ]);
};
/* harmony default export */ var hooks_useEventInfos = (useEventInfos);

;// CONCATENATED MODULE: ./src/views/PancakeSquad/hooks/useUserInfos.tsx








var useUserInfos = function(param) {
    var account = param.account, refreshCounter = param.refreshCounter, setCallback = param.setCallback;
    (0,react.useEffect)(function() {
        var fetchUserInfos = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var nftSaleAddress, pancakeSquadContract, calls, ref, ref1, currentCanClaimForGen0, ref2, currentNumberTicketsForGen0, ref3, currentNumberTicketsUsedForGen0, ref4, currentNumberTicketsOfUser, ref5, currentTicketsOfUser, currentNumberTokensOfUser;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            nftSaleAddress = (0,addressHelpers/* getNftSaleAddress */.L$)();
                            pancakeSquadContract = (0,contractHelpers/* getPancakeSquadContract */.DR)();
                            if (!account) {
                                _ctx.next = 24;
                                break;
                            }
                            calls = [
                                "canClaimForGen0",
                                "numberTicketsForGen0",
                                "numberTicketsUsedForGen0",
                                "viewNumberTicketsOfUser",
                                "ticketsOfUserBySize", 
                            ].map(function(method) {
                                return {
                                    address: nftSaleAddress,
                                    name: method,
                                    params: method === "ticketsOfUserBySize" ? [
                                        account,
                                        0,
                                        600
                                    ] : [
                                        account
                                    ]
                                };
                            });
                            _ctx.t0 = _sliced_to_array/* default */.Z;
                            _ctx.next = 8;
                            return (0,multicall/* multicallv2 */.v)({
                                abi: nftSale,
                                calls: calls
                            });
                        case 8:
                            _ctx.t1 = _ctx.sent;
                            ref = (0, _ctx.t0)(_ctx.t1, 5);
                            ref1 = (0,_sliced_to_array/* default */.Z)(ref[0], 1);
                            currentCanClaimForGen0 = ref1[0];
                            ref2 = (0,_sliced_to_array/* default */.Z)(ref[1], 1);
                            currentNumberTicketsForGen0 = ref2[0];
                            ref3 = (0,_sliced_to_array/* default */.Z)(ref[2], 1);
                            currentNumberTicketsUsedForGen0 = ref3[0];
                            ref4 = (0,_sliced_to_array/* default */.Z)(ref[3], 1);
                            currentNumberTicketsOfUser = ref4[0];
                            ref5 = (0,_sliced_to_array/* default */.Z)(ref[4], 1);
                            currentTicketsOfUser = ref5[0];
                            _ctx.next = 22;
                            return pancakeSquadContract.balanceOf(account);
                        case 22:
                            currentNumberTokensOfUser = _ctx.sent;
                            setCallback({
                                canClaimForGen0: currentCanClaimForGen0,
                                numberTicketsForGen0: currentNumberTicketsForGen0.toNumber(),
                                numberTicketsUsedForGen0: currentNumberTicketsUsedForGen0.toNumber(),
                                numberTicketsOfUser: currentNumberTicketsOfUser.toNumber(),
                                ticketsOfUser: currentTicketsOfUser,
                                numberTokensOfUser: currentNumberTokensOfUser.toNumber()
                            });
                        case 24:
                            _ctx.next = 29;
                            break;
                        case 26:
                            _ctx.prev = 26;
                            _ctx.t2 = _ctx["catch"](0);
                            console.error(_ctx.t2);
                        case 29:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        26
                    ]
                ]);
            }));
            return function fetchUserInfos() {
                return _ref.apply(this, arguments);
            };
        }();
        if (nftSale.length > 0) {
            fetchUserInfos();
        }
    }, [
        account,
        refreshCounter,
        setCallback
    ]);
};
/* harmony default export */ var hooks_useUserInfos = (useUserInfos);

;// CONCATENATED MODULE: ./src/views/PancakeSquad/index.tsx
















var REFRESH_INTERVAL = 4000;
var PancakeSquad = function() {
    var account = (0,src/* useWeb3React */.Ge)().account;
    var ref = (0,hooks/* useProfile */.Un)(), hasProfile = ref.hasProfile, isInitialized = ref.isInitialized;
    var ref1 = (0,react.useState)(), eventInfos = ref1[0], setEventInfo = ref1[1];
    var ref2 = (0,react.useState)(), userInfos = ref2[0], setUserInfos = ref2[1];
    var ref3 = (0,react.useState)(0), refreshCounter = ref3[0], setRefreshCounter = ref3[1];
    var ref4 = (0,react.useState)(false), isUserEnabled = ref4[0], setIsUserEnabled = ref4[1];
    var isLoading = (!eventInfos || !userInfos) && (nftSale === null || nftSale === void 0 ? void 0 : nftSale.length) > 0;
    hooks_useEventInfos({
        setCallback: setEventInfo,
        refreshCounter: refreshCounter
    });
    hooks_useUserInfos({
        setCallback: setUserInfos,
        refreshCounter: refreshCounter,
        account: account
    });
    var userStatus = getUserStatus({
        account: account,
        hasActiveProfile: hasProfile && isInitialized,
        hasGen0: userInfos === null || userInfos === void 0 ? void 0 : userInfos.canClaimForGen0
    });
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            setRefreshCounter(function(prev) {
                return prev + 1;
            });
        }, REFRESH_INTERVAL);
        return function() {
            return clearInterval(interval);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (account) {
            setIsUserEnabled(false);
            setUserInfos(undefined);
        }
    }, [
        account
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PancakeSquadContext.Provider, {
        value: {
            isUserEnabled: isUserEnabled,
            setIsUserEnabled: setIsUserEnabled
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSquadContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                    account: account,
                    isLoading: isLoading,
                    userInfos: userInfos,
                    eventInfos: eventInfos,
                    userStatus: userStatus
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BunniesSection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EventDescriptionSection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EventStepsSection, {
                    userInfos: userInfos,
                    eventInfos: eventInfos,
                    userStatus: userStatus,
                    isLoading: isLoading,
                    account: account
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ArtistSection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqSection, {})
            ]
        })
    });
};
/* harmony default export */ var views_PancakeSquad = (PancakeSquad);

;// CONCATENATED MODULE: ./src/pages/shadow-puppet.tsx

/* harmony default export */ var shadow_puppet = (views_PancakeSquad);


/***/ }),

/***/ 13471:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var MINUTE_IN_SECONDS = 60;
var HOUR_IN_SECONDS = 3600;
var DAY_IN_SECONDS = 86400;
var MONTH_IN_SECONDS = 2629800;
var YEAR_IN_SECONDS = 31557600;
/**
 * Format number of seconds into year, month, day, hour, minute, seconds
 *
 * @param seconds
 */ var getTimePeriods = function(seconds) {
    var delta = Math.abs(seconds);
    var timeLeft = {
        years: 0,
        months: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    };
    if (delta >= YEAR_IN_SECONDS) {
        timeLeft.years = Math.floor(delta / YEAR_IN_SECONDS);
        delta -= timeLeft.years * YEAR_IN_SECONDS;
    }
    if (delta >= MONTH_IN_SECONDS) {
        timeLeft.months = Math.floor(delta / MONTH_IN_SECONDS);
        delta -= timeLeft.months * MONTH_IN_SECONDS;
    }
    if (delta >= DAY_IN_SECONDS) {
        timeLeft.days = Math.floor(delta / DAY_IN_SECONDS);
        delta -= timeLeft.days * DAY_IN_SECONDS;
    }
    if (delta >= HOUR_IN_SECONDS) {
        timeLeft.hours = Math.floor(delta / HOUR_IN_SECONDS);
        delta -= timeLeft.hours * HOUR_IN_SECONDS;
    }
    if (delta >= MINUTE_IN_SECONDS) {
        timeLeft.minutes = Math.floor(delta / MINUTE_IN_SECONDS);
        delta -= timeLeft.minutes * MINUTE_IN_SECONDS;
    }
    timeLeft.seconds = delta;
    return timeLeft;
};
/* harmony default export */ __webpack_exports__["Z"] = (getTimePeriods);


/***/ }),

/***/ 35831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ requiresApproval; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2593);



var requiresApproval = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(contract, account, spenderAddress) {
        var minimumRequired, response, hasMinimumRequired, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    minimumRequired = _args.length > 3 && _args[3] !== void 0 ? _args[3] : 0;
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return contract.allowance(account, spenderAddress);
                case 4:
                    response = _ctx.sent;
                    hasMinimumRequired = typeof minimumRequired === "number" && minimumRequired > 0 || _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_2__/* .BigNumber.isBigNumber */ .O$.isBigNumber(minimumRequired) && minimumRequired.gt(0);
                    if (!hasMinimumRequired) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", response.lt(minimumRequired));
                case 8:
                    return _ctx.abrupt("return", response.lte(0));
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](1);
                    return _ctx.abrupt("return", true);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                11
            ]
        ]);
    }));
    return function requiresApproval(contract, account, spenderAddress) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 51063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69589);
/* harmony import */ var hooks_useTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63850);






var ColoredWordHeading = function(_param) {
    var text = _param.text, firstColor = _param.firstColor, _mb = _param.mb, mb = _mb === void 0 ? "24px" : _mb, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "text",
        "firstColor",
        "mb"
    ]);
    var theme = (0,hooks_useTheme__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)().theme;
    var split = text.split(" ");
    var firstWord = split[0];
    var remainingWords = split.slice(1).join(" ");
    var ref;
    var displayedColor = (ref = theme.colors[firstColor]) !== null && ref !== void 0 ? ref : theme.colors.secondary;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        scale: "xl",
        mb: mb
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                style: {
                    color: displayedColor
                },
                children: [
                    firstWord,
                    " "
                ]
            }),
            remainingWords
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ColoredWordHeading);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1689,9774,2888,179], function() { return __webpack_exec__(33884); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);